// src/components/product-gallery/product-gallery.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment GalleryButtonsFragment on ProductImageGallery {\n    galleryButtons {\n      accessibility\n      icon {\n        description\n        id\n      }\n      action {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyImageFragment on ProductImageInfo {\n    image {\n      url\n      description\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    lowResImage {\n      url\n    }\n    analytics {\n      trackingId\n      imageId\n      subjectId\n    }\n    description\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment CarouselContainerFragment on ProductImageGallery {\n    accessibilityLabel\n    categoryIdAll\n    categorizedImages {\n      accessibilityLabel\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      images {\n        ...PropertyImageFragment\n      }\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment MosaicContainerFragment on ProductImageGallery {\n    accessibilityLabel\n    categorizedImages {\n      accessibilityLabel\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      images {\n        ...PropertyImageFragment\n      }\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment MediaGalleryDialogFragment on ProductImageGallery {\n    categorizedImages {\n      categoryId\n      categoryName\n      images {\n        ...PropertyImageFragment\n      }\n    }\n    mediaGalleryDialog {\n      toolbar {\n        icon {\n          id\n          description\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment ThumbnailGalleryDialogFragment on ProductImageGallery {\n    categorizedImages {\n      categoryId\n      categoryName\n      images {\n        ...PropertyImageFragment\n      }\n      galleryButton {\n        button {\n          ... on UISecondaryButton {\n            accessibility\n            primary\n            analytics {\n              referrerId\n              linkName\n            }\n          }\n        }\n      }\n    }\n    thumbnailGalleryDialog {\n      toolbar {\n        title\n        icon {\n          id\n          description\n        }\n      }\n      trigger {\n        accessibilityLabel\n        value\n      }\n      primaryButton {\n        button {\n          ... on UIPrimaryButton {\n            primary\n            accessibility\n            analytics {\n              referrerId\n              linkName\n            }\n          }\n        }\n        targetRef\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment ProductGalleryImageContainerFragment on ProductImageGallery {\n    ...MosaicContainerFragment\n    ...CarouselContainerFragment\n    ...MediaGalleryDialogFragment\n    ...ThumbnailGalleryDialogFragment\n    ...GalleryButtonsFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  query ProductGalleryQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    productGallery(context: $context, productIdentifier: $productIdentifier) {\n      ...ProductGalleryImageContainerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
import React18 from "react";
import { gql as gql8, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { __Query as __RandomAccessOneQuery, IdentifierType as IdentifierType2 } from "@shared-ui/retail-product-random-access-one";
import { useMockData } from "@shared-ui/retail-product-type-providers";
import { useSignalPublisher } from "@shared-ui/signal-events-context";
// src/context/random-access-one-image-context.tsx
import React, { createContext, useMemo } from "react";
var RandomAccessOneImageContext = createContext({
    isRandomAccessOne: false,
    data: void 0
});
var RandomAccessOneImageContextProvider = function(param) {
    var data = param.data, children = param.children;
    var contextValue = useMemo(function() {
        var _data_randomAccessOne_mapping, _data_randomAccessOne;
        return {
            isRandomAccessOne: !!(data === null || data === void 0 ? void 0 : (_data_randomAccessOne = data.randomAccessOne) === null || _data_randomAccessOne === void 0 ? void 0 : (_data_randomAccessOne_mapping = _data_randomAccessOne.mapping) === null || _data_randomAccessOne_mapping === void 0 ? void 0 : _data_randomAccessOne_mapping.length),
            data: data
        };
    }, [
        data
    ]);
    return /* @__PURE__ */ React.createElement(RandomAccessOneImageContext.Provider, {
        value: contextValue
    }, children);
};
// src/components/product-gallery/product-gallery-image-container.tsx
import React16, { useContext as useContext2 } from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid5 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition6 } from "@egds/react-core/layout-position";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSBlockSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSThemeProvider } from "@egds/react-core/utils";
import { useDialog } from "@shared-ui/dialog-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2, useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/components/utils/query-params.ts
import { useCallback, useMemo as useMemo2 } from "react";
import { useHistory, useLocation } from "react-router-dom";
function useQueryParams() {
    var location = useLocation();
    return useMemo2(function() {
        return new URLSearchParams(location.search);
    }, [
        location.search
    ]);
}
function useDeleteParam() {
    var history = useHistory();
    return useCallback(function(key) {
        var params = new URLSearchParams(history.location.search);
        params.delete(key);
        history.replace("".concat(history.location.pathname, "?").concat(params));
    }, [
        history
    ]);
}
// src/components/product-gallery/product-gallery-image-container.tsx
import { IdentifierType, RandomAccessOne } from "@shared-ui/retail-product-random-access-one";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/components/product-gallery/__private/utils/google-aerial-view.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var accessToken = "AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68";
var fetchAerialViewVideo = function(videoId) {
    return fetch("https://aerialview.googleapis.com/v1/videos:lookupVideo?key=".concat(accessToken, "&videoId=").concat(videoId), {
        method: "GET",
        headers: new Headers({
            "Content-Type": "application/json",
            Referer: "https://www.expedia.com/"
        })
    }).then(function(response) {
        return response.json();
    });
};
var AERIAL_EVENTS = {
    VIDEO_SUCCESS: new SystemEvent(SystemEventLevel.INFO, "VIDEO_SUCCESS"),
    VIDEO_FAILED: new SystemEvent(SystemEventLevel.ERROR, "VIDEO_FAILED")
};
var AERIAL_VIEW_LOGGING = {
    SUCCESS: "Successful lookupVideo call for aerial view, propertyId=",
    FAILURE: "lookupVideo call failed for aerial view, propertyId=",
    TEST_ERROR: "Video not found."
};
var buildEgClickstreamData = function(name, type) {
    var result = {
        event: {
            event_name: name,
            event_type: type,
            event_version: "1.0.0",
            event_category: ""
        },
        experience: {
            app_name: "shared-ui",
            app_version: "1.0.0",
            page_name: "PDP Page"
        }
    };
    return result;
};
// src/context/product-gallery-adaptex-provider.tsx
import React2, { createContext as createContext2, useMemo as useMemo3, useState } from "react";
var defaultValue = {
    useControlBehaviour: false,
    setAdaptExState: function() {
        return void 0;
    },
    eventType: void 0,
    setAdaptExSuccessEvent: function() {
        return void 0;
    }
};
var ProductGalleryContext = createContext2(defaultValue);
var ProductGalleryAdaptExProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(false), 2), useControlBehaviour = _useState[0], setAdaptExState = _useState[1];
    var _useState1 = _sliced_to_array(useState(void 0), 2), eventType = _useState1[0], setAdaptExSuccessEvent = _useState1[1];
    var value = useMemo3(function() {
        return {
            useControlBehaviour: useControlBehaviour,
            setAdaptExState: setAdaptExState,
            eventType: eventType,
            setAdaptExSuccessEvent: setAdaptExSuccessEvent
        };
    }, [
        useControlBehaviour,
        setAdaptExState,
        eventType,
        setAdaptExSuccessEvent
    ]);
    return /* @__PURE__ */ React2.createElement(ProductGalleryContext.Provider, {
        value: value
    }, children);
};
// src/components/product-gallery/__private/__fragments/containers/carousel-container.tsx
import React8, { useEffect } from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3 } from "@egds/react-core/images";
import { useClickTracker as useClickTracker3, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
// src/components/product-gallery/__private/utils/additional-uis-prime-micro-messages-utils.ts
var getCarouselNextIndex = function(currentIndex, mediaLength, carouselActionId) {
    if (carouselActionId.includes("clickRight")) {
        return currentIndex < mediaLength - 1 ? currentIndex + 1 : 0;
    }
    if (carouselActionId.includes("clickLeft")) {
        return currentIndex > 0 ? currentIndex - 1 : mediaLength - 1;
    }
    return currentIndex;
};
var getCarouselNextIndexWithoutLoop = function(currentIndex, mediaLength, carouselActionId) {
    if (carouselActionId.includes("clickRight") || carouselActionId.includes("scrollRight")) {
        return currentIndex < mediaLength - 1 ? currentIndex + 1 : currentIndex;
    }
    if (carouselActionId.includes("clickLeft") || carouselActionId.includes("scrollLeft")) {
        return currentIndex > 0 ? currentIndex - 1 : 0;
    }
    if (carouselActionId.includes("itemViewed")) {
        return parseInt((carouselActionId === null || carouselActionId === void 0 ? void 0 : carouselActionId.split(".")[(carouselActionId === null || carouselActionId === void 0 ? void 0 : carouselActionId.split(".").length) - 1]) || "0", 10);
    }
    return currentIndex;
};
function additionalUisPrimeMicroMessages(galleryPosition, algoMediaGuid, galleryMaxPosition, imageId, productId, galleryName, galleryCategory) {
    var timestamp = Date.now().toString();
    var imageGalleryMetaTagList = [
        {
            imageGalleryMetaTagValue: timestamp,
            imageGalleryMetaTagType: "DEVICE_TIME_STAMP"
        }
    ];
    if (galleryCategory) {
        imageGalleryMetaTagList.push({
            imageGalleryMetaTagValue: galleryCategory,
            imageGalleryMetaTagType: "GALLERY_FILTER"
        });
    }
    var messages = [
        {
            schemaName: "allHotelProducts",
            messageContent: {
                hotelProducts: [
                    _object_spread({
                        imageGalleryAlgorithm: {
                            name: "heroaesthetics.v20190411-hsc.v20190223"
                        },
                        algoMediaGuid: algoMediaGuid
                    }, productId ? {
                        productId: Number(productId)
                    } : {})
                ]
            }
        },
        {
            schemaName: "imageTracking",
            messageContent: _object_spread({
                galleryName: galleryName,
                galleryType: "GALLERY_TYPE_SINGLE",
                galleryMaxPosition: galleryMaxPosition,
                galleryPosition: galleryPosition,
                repeatedGalleryIndex: null,
                imageGalleryMetaTagList: imageGalleryMetaTagList
            }, imageId ? {
                images: [
                    {
                        id: imageId,
                        galleryPosition: galleryPosition
                    }
                ]
            } : {})
        }
    ];
    return messages;
}
// src/components/product-gallery/__private/utils/to-uitk-images.ts
function toEGDSImages(images) {
    return images.map(function(img) {
        var _img_image;
        var _img_image_url, _img_image_description, _img_description, _ref;
        return {
            src: (_img_image_url = img.image.url) !== null && _img_image_url !== void 0 ? _img_image_url : "",
            caption: (_img_image_description = (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_ref = (_img_description = img.description) !== null && _img_description !== void 0 ? _img_description : img.image.description) !== null && _ref !== void 0 ? _ref : ""
        };
    });
}
function toEGDSImagesWithThumbnailAnalytics(images) {
    return images.map(function(img) {
        var _img_image, _img_analytics, _img_analytics1;
        var _img_image_url, _img_description, _ref, _img_image_description, _img_description1, _ref1;
        return {
            src: (_img_image_url = img.image.url) !== null && _img_image_url !== void 0 ? _img_image_url : "",
            caption: (_ref = (_img_description = img.description) !== null && _img_description !== void 0 ? _img_description : img.image.description) !== null && _ref !== void 0 ? _ref : "",
            displayCaption: (_img_image_description = img.image.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_ref1 = (_img_description1 = img.description) !== null && _img_description1 !== void 0 ? _img_description1 : img.image.description) !== null && _ref1 !== void 0 ? _ref1 : "",
            thumbnailClickAnalytics: (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.analytics,
            trackingId: ((_img_analytics = img.analytics) === null || _img_analytics === void 0 ? void 0 : _img_analytics.trackingId) || null,
            imageId: ((_img_analytics1 = img.analytics) === null || _img_analytics1 === void 0 ? void 0 : _img_analytics1.imageId) || null
        };
    });
}
// src/components/product-gallery/__private/gallery-buttons/gallery-buttons.tsx
import React4 from "react";
import { gql } from "@apollo/client";
import { EGDSOverlayButton } from "@egds/react-core/button";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// src/components/product-gallery/__private/__fragments/carousel/tracker-wrapper.tsx
import React3 from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var TrackerWrapper = function(param) {
    var children = param.children, aerialViewButton = param.aerialViewButton;
    return aerialViewButton ? /* @__PURE__ */ React3.createElement(EgClickstreamImpressionTracker, {
        eventData: buildEgClickstreamData("aerial_view.presented", "Impression")
    }, children) : children;
};
// src/components/product-gallery/__private/gallery-buttons/gallery-buttons.tsx
var __GalleryButtonsFragment = gql(_templateObject());
var TRIGGER_POSITION = {
    position: {
        zindex: "layer2",
        bottom: "three",
        right: "three"
    },
    type: "absolute"
};
var GalleryButtons = function(props) {
    var data = props.data, onThumbnailGalleryClick = props.onThumbnailGalleryClick, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, thumbnailButtonText = props.thumbnailButtonText, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel, propertyId = props.propertyId;
    var galleryButtons = data.galleryButtons;
    var track = useClickTracker();
    var trackEGClickStream = useEgClickstream();
    var handleVirtualTourClick = React4.useCallback(function(index) {
        var _galleryButtons_index_icon, _galleryButtons_index, _galleryButtons_index_action, _galleryButtons_index1, _galleryButtons_index_icon1, _galleryButtons_index2, _galleryButtons_index_action1, _galleryButtons_index3;
        if ((galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index = galleryButtons[index]) === null || _galleryButtons_index === void 0 ? void 0 : (_galleryButtons_index_icon = _galleryButtons_index.icon) === null || _galleryButtons_index_icon === void 0 ? void 0 : _galleryButtons_index_icon.id) === "tour_360" && ((_galleryButtons_index1 = galleryButtons[index]) === null || _galleryButtons_index1 === void 0 ? void 0 : (_galleryButtons_index_action = _galleryButtons_index1.action) === null || _galleryButtons_index_action === void 0 ? void 0 : _galleryButtons_index_action.resource)) {
            var _galleryButtons_index_action_resource, _galleryButtons_index_action2, _galleryButtons_index4;
            var btnVal = (galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index4 = galleryButtons[index]) === null || _galleryButtons_index4 === void 0 ? void 0 : (_galleryButtons_index_action2 = _galleryButtons_index4.action) === null || _galleryButtons_index_action2 === void 0 ? void 0 : (_galleryButtons_index_action_resource = _galleryButtons_index_action2.resource) === null || _galleryButtons_index_action_resource === void 0 ? void 0 : _galleryButtons_index_action_resource.value) || "";
            onVirtualTourClick(btnVal);
        } else if ((galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index2 = galleryButtons[index]) === null || _galleryButtons_index2 === void 0 ? void 0 : (_galleryButtons_index_icon1 = _galleryButtons_index2.icon) === null || _galleryButtons_index_icon1 === void 0 ? void 0 : _galleryButtons_index_icon1.id) === "visibility" && ((_galleryButtons_index3 = galleryButtons[index]) === null || _galleryButtons_index3 === void 0 ? void 0 : (_galleryButtons_index_action1 = _galleryButtons_index3.action) === null || _galleryButtons_index_action1 === void 0 ? void 0 : _galleryButtons_index_action1.resource)) {
            var _galleryButtons_index_action_resource1, _galleryButtons_index_action3, _galleryButtons_index5;
            var btnVal1 = (galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index5 = galleryButtons[index]) === null || _galleryButtons_index5 === void 0 ? void 0 : (_galleryButtons_index_action3 = _galleryButtons_index5.action) === null || _galleryButtons_index_action3 === void 0 ? void 0 : (_galleryButtons_index_action_resource1 = _galleryButtons_index_action3.resource) === null || _galleryButtons_index_action_resource1 === void 0 ? void 0 : _galleryButtons_index_action_resource1.value) || "";
            trackEGClickStream(buildEgClickstreamData("aerial_view.selected", "Interaction"));
            onAerialViewClick(btnVal1.replace("#", ""));
        }
    }, [
        galleryButtons,
        trackEGClickStream,
        onVirtualTourClick,
        onAerialViewClick
    ]);
    var thubnailButtonAnalytics = React4.useMemo(function() {
        return {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Open Room Gallery dialog",
            callback: function(id, description) {
                track(id, description, void 0, additionalUisPrimeMicroMessages(0, void 0, 0, void 0, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            }
        };
    }, [
        track
    ]);
    return /* @__PURE__ */ React4.createElement(EGDSLayoutPosition, _object_spread({}, TRIGGER_POSITION), /* @__PURE__ */ React4.createElement(EGDSLayoutFlex, {
        space: "two",
        wrap: "nowrap"
    }, galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.map(function(galleryButton, buttonIndex) {
        var _galleryButton_icon, _galleryButton_action, _galleryButton_icon1, _galleryButton_icon2;
        return(// eslint-disable-next-line react/jsx-key
        /* @__PURE__ */ React4.createElement(TrackerWrapper, {
            aerialViewButton: (galleryButton === null || galleryButton === void 0 ? void 0 : (_galleryButton_icon = galleryButton.icon) === null || _galleryButton_icon === void 0 ? void 0 : _galleryButton_icon.id) === "visibility" && (galleryButton === null || galleryButton === void 0 ? void 0 : (_galleryButton_action = galleryButton.action) === null || _galleryButton_action === void 0 ? void 0 : _galleryButton_action.resource)
        }, /* @__PURE__ */ React4.createElement(EGDSOverlayButton, {
            key: "gallery-mosaic-action-".concat((_galleryButton_icon1 = galleryButton.icon) === null || _galleryButton_icon1 === void 0 ? void 0 : _galleryButton_icon1.id),
            "aria-label": "gallery-mosaic-action",
            onClick: function() {
                return handleVirtualTourClick(buttonIndex);
            }
        }, /* @__PURE__ */ React4.createElement(EGDSIcon, {
            name: ((_galleryButton_icon2 = galleryButton.icon) === null || _galleryButton_icon2 === void 0 ? void 0 : _galleryButton_icon2.id) || "",
            id: "gallery-mosaic-action-trigger"
        }), galleryButton.accessibility)));
    }), /* @__PURE__ */ React4.createElement(EGDSOverlayButton, {
        "aria-label": thumbnailDialogTriggerAccessibilityLabel || "",
        onClick: onThumbnailGalleryClick,
        analytics: thubnailButtonAnalytics
    }, /* @__PURE__ */ React4.createElement(EGDSIcon, {
        name: "photo_library",
        id: "gallery-mosaic-thumbnail-trigger"
    }), thumbnailButtonText)));
};
GalleryButtons.displayName = "GalleryButtons";
GalleryButtons.fragment = __GalleryButtonsFragment;
// src/components/product-gallery/__private/__fragments/carousel/carousel.tsx
import React5 from "react";
import { EGDSOverlayButton as EGDSOverlayButton2, UitkButtonSize } from "@egds/react-core/button";
import { EGDSCarousel, EGDSCarouselPaginationDots } from "@egds/react-core/carousel";
import { EGDSIcon as EGDSIcon2, UitkIconSize } from "@egds/react-core/icons";
import { EGDSFigure, EGDSImage, EGDSImageLink } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
var CarouselOverlayButtonComponent = function(param) {
    var button = param.button, onClick = param.onClick, showTextLabel = param.showTextLabel;
    var _button_icon, _button_icon1;
    return /* @__PURE__ */ React5.createElement(EGDSOverlayButton2, {
        "aria-label": (button === null || button === void 0 ? void 0 : button.accessibility) || "",
        size: UitkButtonSize.SMALL,
        onClick: onClick
    }, /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        size: UitkIconSize.SMALL,
        name: (button === null || button === void 0 ? void 0 : (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) || "",
        id: "PhotoGallery-".concat(button === null || button === void 0 ? void 0 : (_button_icon1 = button.icon) === null || _button_icon1 === void 0 ? void 0 : _button_icon1.id)
    }), !showTextLabel && (button === null || button === void 0 ? void 0 : button.accessibility));
};
var VirtualTourButtonComponent = function(param) {
    var button = param.button, onClick = param.onClick, showTextLabel = param.showTextLabel;
    var _button_icon, _button_icon1;
    return /* @__PURE__ */ React5.createElement(EGDSOverlayButton2, {
        "aria-label": (button === null || button === void 0 ? void 0 : button.accessibility) || "",
        size: UitkButtonSize.SMALL,
        onClick: onClick
    }, /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        size: UitkIconSize.SMALL,
        name: (button === null || button === void 0 ? void 0 : (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) || "",
        id: "PhotoGallery-".concat(button === null || button === void 0 ? void 0 : (_button_icon1 = button.icon) === null || _button_icon1 === void 0 ? void 0 : _button_icon1.id)
    }), !showTextLabel && (button === null || button === void 0 ? void 0 : button.accessibility));
};
var NumberOfImagesButtonComponent = function(param) {
    var uitkImages = param.uitkImages, handleMediaButtonClick = param.handleMediaButtonClick;
    var formatText = useLocalization().formatText;
    return /* @__PURE__ */ React5.createElement(EGDSOverlayButton2, {
        size: UitkButtonSize.SMALL,
        onClick: handleMediaButtonClick
    }, /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        name: "photo_library",
        id: "photo_library-id",
        title: formatText("gallerycarousel.mediaGalleryButton", uitkImages.length)
    }), /* @__PURE__ */ React5.createElement("span", {
        "aria-hidden": "true"
    }, String(uitkImages.length)));
};
var Carousel = function(props) {
    var _carouselRef_current, _carouselRef_current1;
    var ratio = props.ratio, uitkImages = props.uitkImages, controlAnalytics = props.controlAnalytics, label = props.label, handleIndexChange = props.handleIndexChange, handleImageClick = props.handleImageClick, handleMediaButtonClick = props.handleMediaButtonClick, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, virtualTourButton = props.virtualTourButton, aerialViewButton = props.aerialViewButton;
    var carouselRef = React5.useRef(null);
    var _React5_useState = _sliced_to_array(React5.useState(0), 2), currentIndex = _React5_useState[0], setCurrentIndex = _React5_useState[1];
    var _useExperiment = useExperiment("mWeb_larger_image_for_top_of_PDP_gallery"), mWebLargerImageExposure = _useExperiment.exposure;
    var ismWebLargerImageVariant = mWebLargerImageExposure.bucket !== 0;
    var onIndexChange = function(index) {
        setCurrentIndex(index);
        handleIndexChange(index);
    };
    return /* @__PURE__ */ React5.createElement(EGDSLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React5.createElement(EGDSCarousel, {
        carouselRef: carouselRef,
        analytics: controlAnalytics,
        carouselHeaderLevel: "h2",
        carouselHeaderText: label || "",
        carouselName: "PhotoGallery",
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1
        },
        onIndexChange: onIndexChange,
        hideNav: ismWebLargerImageVariant,
        pagingPersistent: !ismWebLargerImageVariant,
        pagingInset: !ismWebLargerImageVariant,
        pagingOverlay: !ismWebLargerImageVariant,
        peek: false,
        wrapItems: true,
        buttonText: {
            nextButton: "Show next card",
            prevButton: "Show previous card"
        }
    }, uitkImages.map(function(image, i) {
        return /* @__PURE__ */ React5.createElement(EGDSFigure, {
            ratio: ratio,
            key: i
        }, /* @__PURE__ */ React5.createElement(EGDSImage, {
            placeholderImage: true,
            alt: image.alt,
            src: image.src,
            lazyLoading: "lazy"
        }), /* @__PURE__ */ React5.createElement(EGDSImageLink, null, /* @__PURE__ */ React5.createElement("button", {
            type: "button",
            onClick: handleImageClick
        }, image.alt)));
    })), ((_carouselRef_current = carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : _carouselRef_current.changeIndex) && ismWebLargerImageVariant && /* @__PURE__ */ React5.createElement(EGDSScrim, {
        type: EGDSScrimType.BOTTOM
    }, /* @__PURE__ */ React5.createElement(EGDSCarouselPaginationDots, {
        activeIndex: currentIndex,
        inset: true,
        itemCount: uitkImages.length,
        changeIndex: (_carouselRef_current1 = carouselRef.current) === null || _carouselRef_current1 === void 0 ? void 0 : _carouselRef_current1.changeIndex
    })), ismWebLargerImageVariant ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(EGDSLayoutPosition2, {
        position: {
            bottom: "three",
            left: "three",
            zindex: "layer3"
        },
        type: "absolute"
    }, virtualTourButton && /* @__PURE__ */ React5.createElement(CarouselOverlayButtonComponent, {
        button: virtualTourButton,
        onClick: onVirtualTourClick,
        showTextLabel: ismWebLargerImageVariant
    }), aerialViewButton && /* @__PURE__ */ React5.createElement(CarouselOverlayButtonComponent, {
        button: aerialViewButton,
        onClick: onAerialViewClick,
        showTextLabel: ismWebLargerImageVariant
    })), /* @__PURE__ */ React5.createElement(EGDSLayoutPosition2, {
        position: {
            bottom: "three",
            right: "three",
            zindex: "layer3"
        },
        type: "absolute"
    }, /* @__PURE__ */ React5.createElement(NumberOfImagesButtonComponent, {
        uitkImages: uitkImages,
        handleMediaButtonClick: handleMediaButtonClick
    }))) : /* @__PURE__ */ React5.createElement(EGDSLayoutPosition2, {
        position: {
            bottom: "three",
            right: "three",
            zindex: "layer3"
        },
        type: "absolute"
    }, /* @__PURE__ */ React5.createElement(EGDSLayoutFlex2, {
        space: "two"
    }, /* @__PURE__ */ React5.createElement(EGDSLayoutFlexItem, null, virtualTourButton && /* @__PURE__ */ React5.createElement(VirtualTourButtonComponent, {
        button: virtualTourButton,
        onClick: onVirtualTourClick,
        showTextLabel: ismWebLargerImageVariant
    }), aerialViewButton && /* @__PURE__ */ React5.createElement(CarouselOverlayButtonComponent, {
        button: aerialViewButton,
        onClick: onAerialViewClick,
        showTextLabel: ismWebLargerImageVariant
    })), /* @__PURE__ */ React5.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React5.createElement(NumberOfImagesButtonComponent, {
        uitkImages: uitkImages,
        handleMediaButtonClick: handleMediaButtonClick
    })))));
};
// src/components/product-gallery/__private/__fragments/carousel/intersection-tracker.tsx
import React6 from "react";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var Tracker = function(param) {
    var imageIndex = param.imageIndex, images = param.images, propertyId = param.propertyId, children = param.children;
    var _images_imageIndex_analytics, _images_imageIndex, _images_imageIndex_analytics1, _images_imageIndex1;
    return /* @__PURE__ */ React6.createElement(IntersectionTracker, {
        tag: "span",
        referrerId: "HOT.HIS.MosaicTileImageImpression.".concat(imageIndex),
        linkName: "Mosaic Tile Image Impression",
        trackOnce: true,
        additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(imageIndex, (_images_imageIndex = images[imageIndex]) === null || _images_imageIndex === void 0 ? void 0 : (_images_imageIndex_analytics = _images_imageIndex.analytics) === null || _images_imageIndex_analytics === void 0 ? void 0 : _images_imageIndex_analytics.trackingId, images.length, (_images_imageIndex1 = images[imageIndex]) === null || _images_imageIndex1 === void 0 ? void 0 : (_images_imageIndex_analytics1 = _images_imageIndex1.analytics) === null || _images_imageIndex_analytics1 === void 0 ? void 0 : _images_imageIndex_analytics1.imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ )
    }, children);
};
// src/components/product-gallery/__private/__fragments/images/property-image.tsx
import React7, { useContext } from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2, EGDSImageLink as EGDSImageLink2 } from "@egds/react-core/images";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var __PropertyImageFragment = gql2(_templateObject1());
var PropertyImage = function(props) {
    var data = props.data, onClick = props.onClick, index = props.index, className = props.className, fetchPriority = props.fetchPriority, galleryLength = props.galleryLength, propertyId = props.propertyId, attributes = _object_without_properties(props, [
        "data",
        "onClick",
        "index",
        "className",
        "fetchPriority",
        "galleryLength",
        "propertyId"
    ]);
    var image = data.image, lowResImage = data.lowResImage, analytics = data.analytics, description = data.description;
    var _ref = analytics || {}, trackingId = _ref.trackingId, imageId = _ref.imageId;
    var thumbnailClickAnalytics = image === null || image === void 0 ? void 0 : image.analytics;
    var track = useClickTracker2();
    var isRandomAccessOne = useContext(RandomAccessOneImageContext).isRandomAccessOne;
    var handleClick = React7.useCallback(function() {
        if (thumbnailClickAnalytics) {
            track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
        }
        onClick(index);
    }, [
        onClick,
        index,
        thumbnailClickAnalytics
    ]);
    var galleryImage = /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(EGDSImage2, {
        alt: description !== null && description !== void 0 ? description : "",
        placeholderImage: true,
        src: (lowResImage === null || lowResImage === void 0 ? void 0 : lowResImage.url) ? lowResImage.url : image.url,
        additionalProps: {
            fetchPriority: fetchPriority
        }
    }), /* @__PURE__ */ React7.createElement(EGDSImageLink2, null, /* @__PURE__ */ React7.createElement("button", {
        onClick: handleClick,
        type: "button"
    }, /* @__PURE__ */ React7.createElement("span", {
        className: "is-visually-hidden"
    }, description))));
    return /* @__PURE__ */ React7.createElement(EGDSFigure2, _object_spread_props(_object_spread({}, attributes), {
        className: className,
        ratio: isRandomAccessOne ? EGDSFigureAspectRatioType2.R3_2 : EGDSFigureAspectRatioType2.R16_9
    }), thumbnailClickAnalytics ? /* @__PURE__ */ React7.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: "HOT.HIS.MosaicTileImageImpression.".concat(index),
        linkName: "Mosaic Tile Image Impression",
        additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, trackingId, galleryLength, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ )
    }, galleryImage) : galleryImage);
};
PropertyImage.displayName = "PropertyImage";
PropertyImage.fragment = __PropertyImageFragment;
// src/components/product-gallery/__private/__fragments/containers/carousel-container.tsx
var __CarouselContainerFragment = gql3(_templateObject2(), GalleryButtons.fragment, PropertyImage.fragment);
var CarouselContainer = function(props) {
    var data = props.data, allImages = props.allImages, onImageClick = props.onImageClick, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, onTriggerClick = props.onTriggerClick, imageIndexState = props.imageIndexState, propertyId = props.propertyId;
    var galleryButtons = data.galleryButtons, accessibilityLabel = data.accessibilityLabel;
    var _React8_useContext = React8.useContext(ProductGalleryContext), setAdaptExSuccessEvent = _React8_useContext.setAdaptExSuccessEvent, useControlBehaviour = _React8_useContext.useControlBehaviour;
    var track = useClickTracker3();
    var trackEgClickStream = useEgClickstream2();
    var _React8_useState = _sliced_to_array(React8.useState(false), 2), logExposure = _React8_useState[0], setLogExposure = _React8_useState[1];
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    useEffect(function() {
        if (useControlBehaviour) {
            setAdaptExSuccessEvent("ADAPTEX_MOSAIC_VIEW_ATTEMPT_EVENT");
        }
    }, []);
    var controlAnalytics = React8.useMemo(function() {
        return {
            id: "HOT.HIS.Main",
            description: "Change image in gallery carousel",
            callback: function(id, desc) {
                var _allImages_nextImageIndex;
                var nextImageIndex = getCarouselNextIndex(imageIndex, allImages.length, id);
                var _ref = ((_allImages_nextImageIndex = allImages[nextImageIndex]) === null || _allImages_nextImageIndex === void 0 ? void 0 : _allImages_nextImageIndex.analytics) || {}, trackingId = _ref.trackingId, imageId = _ref.imageId;
                track(id, desc, void 0, additionalUisPrimeMicroMessages(nextImageIndex, trackingId, allImages.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
            }
        };
    }, [
        track
    ]);
    var handleIndexChange = React8.useCallback(function(index) {
        setImageIndex(index);
        setLogExposure(true);
    }, [
        setImageIndex,
        setLogExposure
    ]);
    var handleImageClick = React8.useCallback(function() {
        var _image_image, _image_analytics, _image_analytics1;
        var image = allImages[imageIndex];
        var thumbnailClickAnalytics = image === null || image === void 0 ? void 0 : (_image_image = image.image) === null || _image_image === void 0 ? void 0 : _image_image.analytics;
        if (thumbnailClickAnalytics) {
            track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
        }
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(imageIndex, image === null || image === void 0 ? void 0 : (_image_analytics = image.analytics) === null || _image_analytics === void 0 ? void 0 : _image_analytics.trackingId, allImages.length, image === null || image === void 0 ? void 0 : (_image_analytics1 = image.analytics) === null || _image_analytics1 === void 0 ? void 0 : _image_analytics1.imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        onImageClick();
        setLogExposure(true);
    }, [
        track,
        onImageClick
    ]);
    var handleMediaButtonClick = React8.useCallback(function() {
        track("HOT.HIS.PhotoGalleryTrigger", "Open Room Gallery dialog");
        onTriggerClick();
        setLogExposure(true);
    }, [
        track,
        onTriggerClick
    ]);
    var virtualTourButton = galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.find(function(button) {
        var _button_icon, _button_action_resource, _button_action;
        return ((_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) === "tour_360" ? (_button_action = button.action) === null || _button_action === void 0 ? void 0 : (_button_action_resource = _button_action.resource) === null || _button_action_resource === void 0 ? void 0 : _button_action_resource.value : null;
    });
    var aerialViewButton = galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.find(function(button) {
        var _button_icon, _button_action_resource, _button_action;
        return ((_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) === "visibility" ? (_button_action = button.action) === null || _button_action === void 0 ? void 0 : (_button_action_resource = _button_action.resource) === null || _button_action_resource === void 0 ? void 0 : _button_action_resource.value : null;
    });
    var handleonVirtualTourButtonClick = React8.useCallback(function() {
        if (virtualTourButton === null || virtualTourButton === void 0 ? void 0 : virtualTourButton.action) {
            onVirtualTourClick(virtualTourButton.action.resource.value);
        }
    }, [
        onVirtualTourClick,
        virtualTourButton
    ]);
    var handleAerialViewButtonClick = React8.useCallback(function() {
        if (aerialViewButton === null || aerialViewButton === void 0 ? void 0 : aerialViewButton.action) {
            var _aerialViewButton_action_resource, _aerialViewButton_action;
            var btnVal = ((_aerialViewButton_action = aerialViewButton.action) === null || _aerialViewButton_action === void 0 ? void 0 : (_aerialViewButton_action_resource = _aerialViewButton_action.resource) === null || _aerialViewButton_action_resource === void 0 ? void 0 : _aerialViewButton_action_resource.value) || "";
            trackEgClickStream(buildEgClickstreamData("aerial_view.selected", "Interaction"));
            onAerialViewClick(btnVal.replace("#", ""));
            setLogExposure(true);
        }
    }, [
        trackEgClickStream,
        onAerialViewClick,
        aerialViewButton
    ]);
    var uitkImages = React8.useMemo(function() {
        return toEGDSImages(allImages);
    }, [
        allImages
    ]);
    var carouselComponent = function(imageRatio) {
        return /* @__PURE__ */ React8.createElement(TrackerWrapper, {
            aerialViewButton: aerialViewButton
        }, /* @__PURE__ */ React8.createElement(Tracker, {
            propertyId: propertyId,
            images: allImages,
            imageIndex: imageIndex
        }, /* @__PURE__ */ React8.createElement(Carousel, {
            ratio: imageRatio,
            uitkImages: uitkImages,
            controlAnalytics: controlAnalytics,
            label: accessibilityLabel,
            handleIndexChange: handleIndexChange,
            handleImageClick: handleImageClick,
            handleMediaButtonClick: handleMediaButtonClick,
            onVirtualTourClick: handleonVirtualTourButtonClick,
            onAerialViewClick: handleAerialViewButtonClick,
            virtualTourButton: virtualTourButton,
            aerialViewButton: aerialViewButton
        })));
    };
    return /* @__PURE__ */ React8.createElement(Experiment, {
        name: "mWeb_larger_image_for_top_of_PDP_gallery",
        logExposure: true
    }, /* @__PURE__ */ React8.createElement(ExperimentControl, null, carouselComponent(EGDSFigureAspectRatioType3.R16_9)), /* @__PURE__ */ React8.createElement(ExperimentVariant, {
        bucket: 1
    }, carouselComponent(EGDSFigureAspectRatioType3.R3_2)), /* @__PURE__ */ React8.createElement(ExperimentVariant, {
        bucket: 2
    }, carouselComponent(EGDSFigureAspectRatioType3.R1_1)));
};
CarouselContainer.displayName = "CarouselContainer";
CarouselContainer.fragment = __CarouselContainerFragment;
// src/components/product-gallery/__private/__fragments/containers/mosaic-container.tsx
import React9 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var __MosaicContainerFragment = gql4(_templateObject3(), GalleryButtons.fragment, PropertyImage.fragment);
function numberOfColumns(numberOfImages) {
    switch(numberOfImages){
        case 5:
            return 4;
        case 3:
            return 3;
        default:
            return 1;
    }
}
var MosaicContainer = function(props) {
    var _mosaicImages_;
    var data = props.data, allImages = props.allImages, imagesToShow = props.imagesToShow, onImageClick = props.onImageClick, propertyId = props.propertyId;
    var accessibilityLabel = data.accessibilityLabel;
    var track = useClickTracker4();
    var mosaicImages = React9.useMemo(function() {
        var imageSlice = allImages.slice(0, imagesToShow);
        if (imageSlice.length % 2 === 0) {
            imageSlice.pop();
        }
        return imageSlice;
    }, [
        allImages,
        imagesToShow
    ]);
    var handleImageClick = React9.useCallback(function(index) {
        var _mosaicImages_index;
        var _ref = ((_mosaicImages_index = mosaicImages[index]) === null || _mosaicImages_index === void 0 ? void 0 : _mosaicImages_index.analytics) || {}, trackingId = _ref.trackingId, imageId = _ref.imageId;
        track("HOT.HIS.ClickMosaicTileImage.".concat(index), "Property mosaic tile image click", void 0, additionalUisPrimeMicroMessages(index, trackingId, mosaicImages.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId, mosaicImages.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        onImageClick(index);
    }, [
        track,
        onImageClick
    ]);
    var columns = numberOfColumns(mosaicImages.length);
    return /* @__PURE__ */ React9.createElement(EGDSLayoutPosition3, {
        type: "relative"
    }, /* @__PURE__ */ React9.createElement(EGDSLayoutGrid, {
        columns: columns,
        rows: 2,
        space: "half"
    }, /* @__PURE__ */ React9.createElement("meta", {
        itemProp: "image",
        content: (_mosaicImages_ = mosaicImages[0]) === null || _mosaicImages_ === void 0 ? void 0 : _mosaicImages_.image.url
    }), /* @__PURE__ */ React9.createElement("h2", {
        className: "is-visually-hidden"
    }, accessibilityLabel), mosaicImages.map(function(img, index) {
        return /* @__PURE__ */ React9.createElement(EGDSLayoutGridItem, {
            key: "mosaic-image-".concat(index),
            colSpan: index === 0 ? 2 : 1,
            rowSpan: index === 0 ? 2 : 1
        }, /* @__PURE__ */ React9.createElement(PropertyImage, {
            data: img,
            onClick: handleImageClick,
            index: index,
            fetchPriority: index === 0 ? "high" : void 0,
            galleryLength: imagesToShow,
            propertyId: propertyId
        }));
    })));
};
MosaicContainer.fragment = __MosaicContainerFragment;
MosaicContainer.displayName = "MosaicContainer";
// src/components/product-gallery/__private/__fragments/dialogs/aerial-view-dialog.tsx
import React10 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSScrim as EGDSScrim2, EGDSScrimType as EGDSScrimType2 } from "@egds/react-core/scrim";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { VideoPlayer } from "@egds/react-property-experience";
import { useClickTracker as useClickTracker5, useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkTransparentToolbar } from "uitk-react-toolbar";
var AerialViewDialog = function(props) {
    var isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, triggerRef = props.triggerRef, aerialViewLandscape = props.aerialViewLandscape, aerialViewDescription = props.aerialViewDescription;
    var track = useClickTracker5();
    var trackEGClickStream = useEgClickstream3();
    var dialogAnalytics = React10.useMemo(function() {
        var callback = function(id, description) {
            track(id, description);
            trackEGClickStream(buildEgClickstreamData("aerial_view.closed", "Interaction"));
        };
        var dialog = {
            id: "HOT.HIS.AerialViewTrigger",
            description: "Close aerial view dialog",
            callback: callback
        };
        return dialog;
    }, [
        track,
        trackEGClickStream
    ]);
    return /* @__PURE__ */ React10.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        liveAnnounceString: "Full Sheet has opened",
        type: "full",
        triggerRef: triggerRef,
        theme: "dark"
    }, /* @__PURE__ */ React10.createElement(UitkTransparentToolbar, {
        overlay: true,
        navigationContent: {
            navButtonId: "UitkMediaGalleryImageToolbar",
            navType: "close",
            navIconLabel: "Close",
            onClick: onDialogDismiss,
            onClickAnalytics: dialogAnalytics
        }
    }), aerialViewLandscape.length > 0 && /* @__PURE__ */ React10.createElement(UitkSheetContent, {
        padded: false
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlex3, {
        justifyContent: "center",
        alignItems: "center",
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React10.createElement(VideoPlayer, {
        src: aerialViewLandscape,
        autoPlay: true,
        muted: true,
        controlsList: "nodownload"
    })), /* @__PURE__ */ React10.createElement(Viewport, null, /* @__PURE__ */ React10.createElement(ViewSmall, null, /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem2, {
        alignSelf: "start"
    }, /* @__PURE__ */ React10.createElement(EGDSSpacing, {
        margin: "three"
    }, /* @__PURE__ */ React10.createElement(EGDSText, {
        theme: "inverse",
        overflow: "wrap"
    }, aerialViewDescription)))), /* @__PURE__ */ React10.createElement(ViewMedium, null, /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React10.createElement(EGDSSpacing, {
        padding: {
            block: "four",
            inline: "three"
        }
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlex3, {
        justifyContent: "space-between",
        alignItems: "end"
    }, /* @__PURE__ */ React10.createElement(EGDSScrim2, {
        type: EGDSScrimType2.BOTTOM
    }, /* @__PURE__ */ React10.createElement(EGDSText, {
        theme: "inverse",
        overflow: "wrap"
    }, aerialViewDescription))))))))));
};
AerialViewDialog.displayName = "AerialViewDialog";
// src/components/product-gallery/__private/__fragments/dialogs/media-gallery-dialog.tsx
import React11 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkPagingNextButton, UitkPagingPrevButton } from "uitk-react-button";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
import { UitkTransparentToolbar as UitkTransparentToolbar2 } from "uitk-react-toolbar";
var __MediaGalleryDialogFragment = gql5(_templateObject4(), PropertyImage.fragment);
var getNavType = function(id) {
    switch(id){
        case "arrow_back":
            return "back";
        default:
            return "close";
    }
};
var bottomOfCarousel = function(carouselRef, currentIndex) {
    var viewPrevCard = function() {
        if (carouselRef.current) {
            carouselRef.current.changeIndex(currentIndex - 1);
        }
    };
    var viewNextCard = function() {
        if (carouselRef.current) {
            carouselRef.current.changeIndex(currentIndex + 1);
        }
    };
    return /* @__PURE__ */ React11.createElement(UitkLayoutFlex, {
        justifyContent: "space-around",
        alignItems: "center"
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkPagingPrevButton, {
        iconId: "prev-button-media-gallery",
        iconTitle: "Show previous card",
        onClick: viewPrevCard
    })), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkPagingNextButton, {
        iconId: "next-button-media-gallery",
        iconTitle: "Show next card",
        onClick: viewNextCard
    })));
};
var MediaGalleryDialog = function(props) {
    var _mediaGalleryDialog_toolbar_icon, _mediaGalleryDialog_toolbar, _mediaGalleryDialog_toolbar_icon1, _mediaGalleryDialog_toolbar1, _galleryImages_currentIndex;
    var data = props.data, allImages = props.allImages, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, imageIndexState = props.imageIndexState, categoryImageIndexState = props.categoryImageIndexState, categoryIndexState = props.categoryIndexState, propertyId = props.propertyId, mediaGalleryStartIndexState = props.mediaGalleryStartIndexState, carouselRef = props.carouselRef;
    var categorizedImages = data.categorizedImages, mediaGalleryDialog = data.mediaGalleryDialog;
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var _categoryImageIndexState = _sliced_to_array(categoryImageIndexState, 2), categoryImageIndex = _categoryImageIndexState[0], setCategoryImageIndex = _categoryImageIndexState[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var _mediaGalleryStartIndexState = _sliced_to_array(mediaGalleryStartIndexState, 2), startIndex = _mediaGalleryStartIndexState[0], setStartIndex = _mediaGalleryStartIndexState[1];
    var _React11_useState = _sliced_to_array(React11.useState(startIndex), 2), currentIndex = _React11_useState[0], setCurrentIndex = _React11_useState[1];
    var track = useClickTracker6();
    var galleryImages = React11.useMemo(function() {
        if (categoryIndex < 0) {
            return toEGDSImages(allImages);
        }
        var currentCategory = categorizedImages ? categorizedImages[categoryIndex] : null;
        return toEGDSImages((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.images) || []);
    }, [
        categoryIndex,
        categorizedImages,
        allImages
    ]);
    var galleryControlAnalytics = React11.useMemo(function() {
        var callback = function(id, description) {
            var _categorizedImages_categoryIndex, _categoryImages_nextImageIndex;
            var nextImageIndex = getCarouselNextIndexWithoutLoop(categoryImageIndex, galleryImages.length, id);
            var categoryImages = (categorizedImages === null || categorizedImages === void 0 ? void 0 : (_categorizedImages_categoryIndex = categorizedImages[categoryIndex]) === null || _categorizedImages_categoryIndex === void 0 ? void 0 : _categorizedImages_categoryIndex.images) || allImages;
            var _ref = ((_categoryImages_nextImageIndex = categoryImages[nextImageIndex]) === null || _categoryImages_nextImageIndex === void 0 ? void 0 : _categoryImages_nextImageIndex.analytics) || {}, trackingId = _ref.trackingId, imageId = _ref.imageId;
            track(id, description, void 0, additionalUisPrimeMicroMessages(nextImageIndex, trackingId, galleryImages.length, imageId, propertyId, "PDP_FULL_SCREEN_IMAGE_GALLERY" /* PDP_FULL_SCREEN_IMAGE_GALLERY */ ));
        };
        var galleryControl = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Change image in media gallery",
            callback: callback
        };
        return galleryControl;
    }, [
        track
    ]);
    var dialogAnalytics = React11.useMemo(function() {
        var callback = function(id, description) {
            var _categorizedImages_categoryIndex, _categoryImages_categoryImageIndex;
            var categoryImages = (categorizedImages === null || categorizedImages === void 0 ? void 0 : (_categorizedImages_categoryIndex = categorizedImages[categoryIndex]) === null || _categorizedImages_categoryIndex === void 0 ? void 0 : _categorizedImages_categoryIndex.images) || allImages;
            var _ref = ((_categoryImages_categoryImageIndex = categoryImages[categoryImageIndex]) === null || _categoryImages_categoryImageIndex === void 0 ? void 0 : _categoryImages_categoryImageIndex.analytics) || {}, trackingId = _ref.trackingId, imageId = _ref.imageId;
            track(id, description, void 0, additionalUisPrimeMicroMessages(categoryImageIndex, trackingId, galleryImages.length, imageId, propertyId, "PDP_FULL_SCREEN_IMAGE_GALLERY" /* PDP_FULL_SCREEN_IMAGE_GALLERY */ ));
        };
        var dialog = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Close review gallery dialog",
            callback: callback
        };
        return dialog;
    }, [
        track
    ]);
    var handleIndexChange = React11.useCallback(function(index) {
        setCurrentIndex(index);
        if (categoryIndex < 0) {
            setImageIndex(index);
            return;
        }
        setCategoryImageIndex(index);
    }, [
        categoryIndex,
        setCategoryImageIndex,
        setImageIndex,
        setCurrentIndex
    ]);
    var triggerRef = React11.createRef();
    var carouselProps = {
        analytics: galleryControlAnalytics,
        carouselHeaderText: "MediaGalleryCarousel",
        carouselName: "MediaGalleryCarousel",
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1
        },
        onIndexChange: handleIndexChange,
        pagingInset: true,
        pagingPersistent: true,
        stretchToFill: false,
        navigationIconId: {
            next: "next-button-media-gallery",
            prev: "prev-button-media-gallery"
        },
        // will update buttonTexts with loc strings once available from BE
        buttonText: {
            nextButton: "Show next card",
            prevButton: "Show previous card"
        },
        pageBy: 1,
        peek: false,
        hideNav: true
    };
    if (!(galleryImages === null || galleryImages === void 0 ? void 0 : galleryImages.length)) {
        return null;
    }
    var images = galleryImages.map(function(sample, i) {
        return /* @__PURE__ */ React11.createElement(UitkFigure, {
            key: i,
            ratio: UitkFigureAspectRatioType.R16_9
        }, /* @__PURE__ */ React11.createElement(UitkImage, {
            alt: sample.alt,
            src: sample.src
        }));
    });
    return /* @__PURE__ */ React11.createElement(UitkSheet2, {
        isVisible: isDialogOpen,
        liveAnnounceString: "Full Sheet has opened",
        type: "full",
        triggerRef: triggerRef,
        theme: "dark"
    }, /* @__PURE__ */ React11.createElement(UitkTransparentToolbar2, {
        overlay: true,
        navigationContent: {
            navButtonId: "UitkMediaGalleryImageToolbar",
            navType: getNavType(mediaGalleryDialog === null || mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar = mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon = _mediaGalleryDialog_toolbar.icon) === null || _mediaGalleryDialog_toolbar_icon === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon.id),
            navIconLabel: mediaGalleryDialog === null || mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar1 = mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar1 === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon1 = _mediaGalleryDialog_toolbar1.icon) === null || _mediaGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon1.description,
            onClick: onDialogDismiss,
            onClickAnalytics: dialogAnalytics
        }
    }), /* @__PURE__ */ React11.createElement(UitkSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React11.createElement(Viewport2, null, /* @__PURE__ */ React11.createElement(ViewSmall2, null, /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkSpacing, {
        padding: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React11.createElement(UitkCarousel, _object_spread_props(_object_spread({}, carouselProps), {
        carouselRef: carouselRef,
        fullSheetVisible: isDialogOpen,
        startIndex: startIndex,
        stretchToFill: true
    }), images))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkSpacing, {
        padding: {
            block: "four",
            inline: "three"
        }
    }, bottomOfCarousel(carouselRef, currentIndex))))), /* @__PURE__ */ React11.createElement(ViewMedium2, null, /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkSpacing, {
        padding: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React11.createElement(UitkCarousel, _object_spread_props(_object_spread({}, carouselProps), {
        carouselRef: carouselRef,
        fullSheetVisible: isDialogOpen,
        startIndex: startIndex
    }), images))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkSpacing, {
        padding: {
            block: "four",
            inline: "three"
        }
    }, bottomOfCarousel(carouselRef, currentIndex))))), /* @__PURE__ */ React11.createElement(ViewLarge, null, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkSpacing, {
        padding: {
            block: "four",
            inline: "three"
        }
    }, /* @__PURE__ */ React11.createElement(UitkCarousel, _object_spread_props(_object_spread({}, carouselProps), {
        hideNav: false,
        fullSheetVisible: isDialogOpen,
        startIndex: startIndex
    }), images))))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkSpacing, {
        padding: {
            block: "four",
            inline: "three"
        }
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlex, {
        justifyContent: "space-between",
        alignItems: "end"
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkText, {
        theme: "inverse",
        overflow: "wrap"
    }, (_galleryImages_currentIndex = galleryImages[currentIndex]) === null || _galleryImages_currentIndex === void 0 ? void 0 : _galleryImages_currentIndex.caption)), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(UitkText, {
        theme: "inverse"
    }, "".concat(String(currentIndex + 1), "/").concat(String(galleryImages.length))))))))));
};
MediaGalleryDialog.displayName = "MediaGalleryDialog";
MediaGalleryDialog.fragment = __MediaGalleryDialogFragment;
// src/components/product-gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
import React15, { useEffect as useEffect2, useState as useState2 } from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSFloatingButton, EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition5 } from "@egds/react-core/layout-position";
import { EGDSSheet, EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { SheetCenteredLarge } from "@egds/react-property-experience";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useRefContext, useRefTargetScroll } from "@shared-ui/ref-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { useInView } from "react-intersection-observer";
// src/components/product-gallery/__private/__fragments/dialogs/thumbnail-gallery-pills.tsx
import React14 from "react";
import { EGDSSecondaryButton, UitkButtonSize as UitkButtonSize2 } from "@egds/react-core/button";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType5 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition4 } from "@egds/react-core/layout-position";
import { EGDSPill } from "@egds/react-core/pill";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { ViewRow } from "@egds/react-search-experience";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { defaultViewSizes, useMediaQueries, ViewLarge as ViewLarge2, ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/product-gallery/__private/__fragments/dialogs/media-gallery-thumbnail-view.tsx
import React12 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSList } from "@egds/react-core/list";
import { EGDSMediaGalleryThumbnail } from "@egds/react-core/media-gallery";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
var MediaGalleryThumbnailView = function(param) {
    var images = param.images, onImageSelected = param.onImageSelected, columns = param.columns, space = param.space, imagesRatio = param.imagesRatio, focusIndex = param.focusIndex, containerRef = param.containerRef, propertyId = param.propertyId, categoryId = param.categoryId;
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    return /* @__PURE__ */ React12.createElement(EGDSList, {
        bullet: "no-bullet",
        spacing: false
    }, /* @__PURE__ */ React12.createElement(EGDSLayoutGrid2, {
        columns: columns,
        space: space
    }, images.map(function(image, index) {
        return /* @__PURE__ */ React12.createElement(EGDSLayoutGridItem2, {
            key: index
        }, /* @__PURE__ */ React12.createElement("div", {
            "data-stid": "image-thumbnail-view-with-label"
        }, image.thumbnailClickAnalytics && /* @__PURE__ */ React12.createElement(IntersectionTracker3, {
            trackOnce: true,
            referrerId: "HOT.HIS.ThumbnailImageImpression.".concat(categoryId ? "".concat(categoryId, ".") : "").concat(index),
            linkName: "Thumbnail Image Impression",
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, image.trackingId, images.length, image.imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ , categoryId)
        }, /* @__PURE__ */ React12.createElement(EGDSMediaGalleryThumbnail, _object_spread_props(_object_spread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        }))), !image.thumbnailClickAnalytics && /* @__PURE__ */ React12.createElement(EGDSMediaGalleryThumbnail, _object_spread_props(_object_spread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        })), /* @__PURE__ */ React12.createElement(EGDSSpacing2, {
            margin: {
                blockstart: "two",
                blockend: "three"
            }
        }, /* @__PURE__ */ React12.createElement(EGDSText2, {
            align: "left",
            overflow: "wrap",
            "aria-hidden": "true"
        }, image.displayCaption))));
    })));
};
MediaGalleryThumbnailView.displayName = "MediaGalleryThumbnailView";
// src/components/product-gallery/__private/__fragments/dialogs/multi-image-layout-view.tsx
import React13 from "react";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4, EGDSImage as EGDSImage3, EGDSImageLink as EGDSImageLink3 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
var MultiImageLayoutView = function(param) {
    var images = param.images, onImageSelected = param.onImageSelected, propertyId = param.propertyId, categoryId = param.categoryId;
    var formatText = useLocalization2().formatText;
    var _obj;
    var isMobile = useViewportMap((_obj = {}, _define_property(_obj, ViewSizes.SMALL, true), _define_property(_obj, ViewSizes.MEDIUM, false), _obj));
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    var imagePosition = function(index) {
        var totalImages = images === null || images === void 0 ? void 0 : images.length;
        if (totalImages < 3) {
            return 2;
        }
        var isEndSpecialCase = totalImages % 3 === 2 && index === totalImages - 2;
        if (isEndSpecialCase) {
            return 1;
        }
        return index % 3 === 0 ? 2 : 1;
    };
    var getImageRatio2 = function(index) {
        if (!isMobile) {
            return EGDSFigureAspectRatioType4.R16_9;
        }
        return imagePosition(index) === 2 ? EGDSFigureAspectRatioType4.R16_9 : EGDSFigureAspectRatioType4.R3_2;
    };
    var buttonLabel = function(image, index) {
        return (image === null || image === void 0 ? void 0 : image.caption) ? formatText("mediagallery.thumbnailWithCaption", image === null || image === void 0 ? void 0 : image.caption) : formatText("mediagallery.thumbnailWithoutCaption", index + 1);
    };
    return /* @__PURE__ */ React13.createElement(EGDSLayoutGrid3, {
        columns: 2,
        space: "two"
    }, images.map(function(image, index) {
        return /* @__PURE__ */ React13.createElement(EGDSLayoutGridItem3, {
            colSpan: {
                small: imagePosition(index),
                medium: 1
            },
            key: index
        }, /* @__PURE__ */ React13.createElement("div", {
            "data-stid": "multi-image-layout-view"
        }, /* @__PURE__ */ React13.createElement(IntersectionTracker4, {
            trackOnce: true,
            referrerId: "HOT.HIS.ThumbnailImageImpression.".concat(categoryId ? "".concat(categoryId, ".") : "").concat(index),
            linkName: "Thumbnail Image Impression",
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, image.trackingId, images.length, image.imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ , categoryId)
        }, /* @__PURE__ */ React13.createElement(EGDSFigure3, {
            ratio: getImageRatio2(index),
            imageFit: "cover",
            roundcorner: {
                medium: [
                    "all"
                ]
            }
        }, /* @__PURE__ */ React13.createElement(EGDSImage3, {
            placeholderImage: true,
            src: image.src,
            alt: image.alt
        }), /* @__PURE__ */ React13.createElement(EGDSImageLink3, null, /* @__PURE__ */ React13.createElement("button", {
            onClick: function() {
                return onImageSelected(index);
            },
            type: "button"
        }, /* @__PURE__ */ React13.createElement("span", {
            className: "is-visually-hidden"
        }, buttonLabel(image, index))))))));
    }));
};
MultiImageLayoutView.displayName = "MultiImageLayoutView";
// src/components/product-gallery/__private/__fragments/dialogs/thumbnail-gallery-pills.tsx
var ThumbnailGalleryPills = function(param) {
    var categories = param.categories, images = param.images, onImageClick = param.onImageClick, categoryIndexState = param.categoryIndexState, imageIndexState = param.imageIndexState, propertyId = param.propertyId, _param_showImageNumber = param.showImageNumber, showImageNumber = _param_showImageNumber === void 0 ? false : _param_showImageNumber, refGallery = param.refGallery, isSmallView = param.isSmallView, refContent = param.refContent, onPillSelect = param.onPillSelect, onThumbnailGalleryButtonClick = param.onThumbnailGalleryButtonClick;
    var _imageIndexState = _sliced_to_array(imageIndexState, 1), imageIndex = _imageIndexState[0];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var useFallbackLogic = !(categories === null || categories === void 0 ? void 0 : categories.length) || categories.length === 1;
    var refTop = React14.useRef(null);
    var refCategory = React14.useRef({});
    var refSticky = React14.useRef(null);
    var track = useClickTracker7();
    var _useExperiment2 = useExperiment2("Multi_image_layout_optimisation_for_gallery_view_Web", true), multiImageLayoutExposure = _useExperiment2.exposure;
    var useMultiImageLayout = multiImageLayoutExposure.bucket !== 0;
    var isDesktop = useMediaQueries({
        viewSizes: defaultViewSizes
    }) >= defaultViewSizes.LARGE;
    var imageColumns = 2;
    var _React14_useState = _sliced_to_array(React14.useState(categoryIndex >= 0 || !(categories === null || categories === void 0 ? void 0 : categories.length) ? categoryIndex : 0), 2), currentLocalCategoryIndex = _React14_useState[0], setCurrentLocalCategoryIndex = _React14_useState[1];
    var _React14_useState1 = _sliced_to_array(React14.useState([]), 2), isPillSelected = _React14_useState1[0], setIsPillSelected = _React14_useState1[1];
    React14.useEffect(function() {
        var newCategories = new Array(categories === null || categories === void 0 ? void 0 : categories.length).fill(false);
        newCategories[0] = !newCategories[0];
        setIsPillSelected(newCategories);
    }, [
        categories
    ]);
    var setRef = function(id) {
        return function(el) {
            refCategory.current[id] = el;
        };
    };
    var handleThumbnailGalleryButtonClick = React14.useCallback(function(analytics) {
        if (analytics) {
            var linkName = analytics.linkName, referrerId = analytics.referrerId;
            track(referrerId, linkName);
        }
        if (onThumbnailGalleryButtonClick) {
            onThumbnailGalleryButtonClick();
        }
    }, [
        track,
        onThumbnailGalleryButtonClick
    ]);
    var handlePillSelect = React14.useCallback(function(selectedCategoryIndex) {
        var _refCategory_current_selectedCategoryIndex, _refSticky_current_offsetParent, _refSticky_current, _refGallery_current_offsetParent, _refGallery_current;
        if (categories) {
            var _categories_selectedCategoryIndex;
            var selectedCategoryName = selectedCategoryIndex >= 0 ? (_categories_selectedCategoryIndex = categories[selectedCategoryIndex]) === null || _categories_selectedCategoryIndex === void 0 ? void 0 : _categories_selectedCategoryIndex.categoryName : "";
            track("HOT.HIS.Gallery.".concat(selectedCategoryName, ".").concat(selectedCategoryIndex), "Selected gallery tab");
        }
        var updateSelectedPill = new Array(isPillSelected.length).fill(false);
        updateSelectedPill[selectedCategoryIndex] = true;
        setIsPillSelected(updateSelectedPill);
        setCurrentLocalCategoryIndex(selectedCategoryIndex);
        if (onPillSelect) {
            onPillSelect(selectedCategoryIndex);
        }
        var location = ((_refCategory_current_selectedCategoryIndex = refCategory.current[selectedCategoryIndex]) === null || _refCategory_current_selectedCategoryIndex === void 0 ? void 0 : _refCategory_current_selectedCategoryIndex.offsetTop) || 0;
        var categoriesHeight = ((_refSticky_current = refSticky.current) === null || _refSticky_current === void 0 ? void 0 : (_refSticky_current_offsetParent = _refSticky_current.offsetParent) === null || _refSticky_current_offsetParent === void 0 ? void 0 : _refSticky_current_offsetParent.clientHeight) || 0;
        refGallery === null || refGallery === void 0 ? void 0 : (_refGallery_current = refGallery.current) === null || _refGallery_current === void 0 ? void 0 : (_refGallery_current_offsetParent = _refGallery_current.offsetParent) === null || _refGallery_current_offsetParent === void 0 ? void 0 : _refGallery_current_offsetParent.scrollTo(0, location - categoriesHeight);
    }, [
        setCurrentLocalCategoryIndex,
        categories,
        track,
        isPillSelected.length,
        refGallery
    ]);
    var handleImageSelected = React14.useCallback(function(index) {
        if (currentLocalCategoryIndex) {
            var _localCategoryImages_index, _localCategoryImages_index_image, _localCategoryImages_index1;
            var localCategory = categories === null || categories === void 0 ? void 0 : categories[currentLocalCategoryIndex];
            var _ref = localCategory || {}, categoryId = _ref.categoryId, tmp = _ref.images, localCategoryImages = tmp === void 0 ? [] : tmp;
            var _ref1 = ((_localCategoryImages_index = localCategoryImages[index]) === null || _localCategoryImages_index === void 0 ? void 0 : _localCategoryImages_index.analytics) || {}, trackingId = _ref1.trackingId, imageId = _ref1.imageId;
            var thumbnailClickAnalytics = (_localCategoryImages_index1 = localCategoryImages[index]) === null || _localCategoryImages_index1 === void 0 ? void 0 : (_localCategoryImages_index_image = _localCategoryImages_index1.image) === null || _localCategoryImages_index_image === void 0 ? void 0 : _localCategoryImages_index_image.analytics;
            var localCategoryImagesLength = localCategoryImages.length;
            track("HOT.HIS.ClickThumbnailImage.".concat(categoryId, ".").concat(index), "Launch Thumbnail Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId, localCategoryImagesLength, imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            if (thumbnailClickAnalytics) {
                track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        } else {
            var _images_index, _images_index_image, _images_index1;
            var _ref2 = ((_images_index = images[index]) === null || _images_index === void 0 ? void 0 : _images_index.analytics) || {}, trackingId1 = _ref2.trackingId, imageId1 = _ref2.imageId;
            var thumbnailClickAnalytics1 = (_images_index1 = images[index]) === null || _images_index1 === void 0 ? void 0 : (_images_index_image = _images_index1.image) === null || _images_index_image === void 0 ? void 0 : _images_index_image.analytics;
            track("HOT.HIS.ClickThumbnailImage.".concat(index), "Launch Thumbnail Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId1, images.length, imageId1, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            if (thumbnailClickAnalytics1) {
                track(thumbnailClickAnalytics1 === null || thumbnailClickAnalytics1 === void 0 ? void 0 : thumbnailClickAnalytics1.referrerId, thumbnailClickAnalytics1 === null || thumbnailClickAnalytics1 === void 0 ? void 0 : thumbnailClickAnalytics1.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        }
    }, [
        currentLocalCategoryIndex,
        onImageClick,
        categories,
        track,
        images,
        propertyId
    ]);
    var thumbnailViewWithImageLabel = React14.useCallback(function(galleryImages, columns, categoryId) {
        return /* @__PURE__ */ React14.createElement(MediaGalleryThumbnailView, {
            imagesRatio: EGDSFigureAspectRatioType5.R16_9,
            images: galleryImages,
            onImageSelected: handleImageSelected,
            columns: columns,
            space: "three",
            focusIndex: imageIndex,
            propertyId: propertyId,
            categoryId: categoryId
        });
    }, [
        handleImageSelected,
        imageIndex,
        propertyId
    ]);
    var multiLayoutImageView = React14.useCallback(function(galleryImages, categoryId) {
        return /* @__PURE__ */ React14.createElement(MultiImageLayoutView, {
            images: galleryImages,
            onImageSelected: handleImageSelected,
            propertyId: propertyId,
            categoryId: categoryId
        });
    }, [
        handleImageSelected,
        imageIndex,
        propertyId
    ]);
    var mediaGalleryThumbnailViewBody = React14.useCallback(function(galleryImages, title, categoryId, columns, headingSize, headingTag, galleryButton, indexCategory) {
        var selectedSection = indexCategory === currentLocalCategoryIndex;
        var _ref = (galleryButton === null || galleryButton === void 0 ? void 0 : galleryButton.button) || {}, galleryButtonAnalytics = _ref.analytics, galleryButtonText = _ref.primary, galleryButtonAccessibility = _ref.accessibility;
        var body = /* @__PURE__ */ React14.createElement(React14.Fragment, null, title && /* @__PURE__ */ React14.createElement(EGDSSpacing3, {
            padding: {
                blockend: "three",
                small: {
                    inline: useMultiImageLayout ? "three" : "unset"
                },
                medium: {
                    inline: "unset"
                }
            }
        }, /* @__PURE__ */ React14.createElement(EGDSHeading, {
            tag: headingTag,
            size: headingSize,
            id: "category-".concat(indexCategory)
        }, /* @__PURE__ */ React14.createElement("div", {
            ref: setRef(indexCategory)
        }, title))), galleryButtonText && /* @__PURE__ */ React14.createElement(EGDSSpacing3, {
            margin: {
                blockend: "three",
                small: {
                    inline: useMultiImageLayout ? "three" : "unset"
                },
                medium: {
                    inline: "unset"
                }
            }
        }, /* @__PURE__ */ React14.createElement(EGDSSecondaryButton, {
            "data-stid": "category-gallery-button",
            "aria-label": galleryButtonAccessibility !== null && galleryButtonAccessibility !== void 0 ? galleryButtonAccessibility : void 0,
            size: UitkButtonSize2.MEDIUM,
            onClick: function() {
                return handleThumbnailGalleryButtonClick(galleryButtonAnalytics);
            }
        }, galleryButtonText)), useMultiImageLayout ? multiLayoutImageView(galleryImages, categoryId) : thumbnailViewWithImageLabel(galleryImages, columns, categoryId));
        if (selectedSection || useFallbackLogic) {
            return /* @__PURE__ */ React14.createElement(EGDSSpacing3, {
                padding: {
                    blockend: "three",
                    small: {
                        inline: useMultiImageLayout ? "unset" : "three"
                    },
                    medium: {
                        inline: "three"
                    }
                }
            }, /* @__PURE__ */ React14.createElement("div", null, body));
        }
    }, [
        thumbnailViewWithImageLabel,
        currentLocalCategoryIndex,
        multiLayoutImageView
    ]);
    var mediaGalleryThumbnailView = React14.useCallback(function(galleryImages, title, categoryId, galleryButton) {
        var indexCategory = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
        return /* @__PURE__ */ React14.createElement(Viewport3, null, /* @__PURE__ */ React14.createElement(ViewSmall3, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, 1, 4, "h4", galleryButton, indexCategory)), /* @__PURE__ */ React14.createElement(ViewMedium3, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, imageColumns, 3, "h3", galleryButton, indexCategory)), /* @__PURE__ */ React14.createElement(ViewLarge2, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, imageColumns, 3, "h3", galleryButton, indexCategory)));
    }, [
        mediaGalleryThumbnailViewBody,
        imageColumns
    ]);
    var pillContent = React14.useCallback(function(category, indexCategory) {
        var defaultPillView = mediaGalleryThumbnailView(toEGDSImagesWithThumbnailAnalytics(category.images), category.categoryName, category.categoryId, category.galleryButton || void 0, indexCategory);
        return defaultPillView;
    }, [
        mediaGalleryThumbnailView
    ]);
    if (!(categories === null || categories === void 0 ? void 0 : categories.length) || categories.length === 1) {
        return mediaGalleryThumbnailView(toEGDSImagesWithThumbnailAnalytics(images), void 0, void 0, void 0, 0);
    }
    var pillsContent = /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(EGDSLayoutPosition4, {
        type: "sticky",
        position: {
            top: "zero",
            zindex: "layer2"
        },
        display: "block"
    }, /* @__PURE__ */ React14.createElement(EGDSSpacing3, {
        padding: {
            small: {
                block: "one",
                inline: "three"
            },
            medium: {
                block: "one",
                inline: "three"
            },
            large: {
                block: "three",
                inline: "three"
            }
        }
    }, /* @__PURE__ */ React14.createElement(ViewRow, {
        layout: "fullwidth",
        paddedViewRow: false,
        canvasTheme: "primary"
    }, /* @__PURE__ */ React14.createElement("div", {
        ref: refSticky
    }, /* @__PURE__ */ React14.createElement(EGDSScrollable, {
        direction: "horizontal"
    }, /* @__PURE__ */ React14.createElement(EGDSSpacing3, {
        padding: {
            small: {
                block: "three"
            },
            medium: {
                block: "three"
            },
            large: {
                block: "one"
            }
        }
    }, /* @__PURE__ */ React14.createElement(EGDSLayoutPosition4, {
        type: "relative"
    }, /* @__PURE__ */ React14.createElement(EGDSLayoutFlex4, null, categories.map(function(category, i) {
        var imageLength = category.images.length;
        var pillText = showImageNumber ? "".concat(category === null || category === void 0 ? void 0 : category.categoryName, " (").concat(imageLength, ")") : category === null || category === void 0 ? void 0 : category.categoryName;
        return /* @__PURE__ */ React14.createElement(EGDSPill, {
            key: "thumbail-gallery-pill-".concat(i),
            id: "thumbail-gallery-pill-".concat(i),
            checked: isPillSelected[i],
            onChange: function() {
                return handlePillSelect(i);
            },
            value: category === null || category === void 0 ? void 0 : category.categoryName
        }, pillText);
    }))))))))), isSmallView ? /* @__PURE__ */ React14.createElement(EGDSLayoutGrid4, {
        blockSize: "85vb"
    }, /* @__PURE__ */ React14.createElement(EGDSScrollable, {
        direction: "vertical"
    }, /* @__PURE__ */ React14.createElement("div", {
        ref: refContent,
        style: {
            height: "1px"
        }
    }), categories.map(function(category, i) {
        return pillContent(category, i);
    }))) : categories.map(function(category, i) {
        return pillContent(category, i);
    }));
    if (useFallbackLogic) {
        return mediaGalleryThumbnailView(toEGDSImagesWithThumbnailAnalytics(images));
    }
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement("div", {
        ref: refTop
    }), /* @__PURE__ */ React14.createElement(EGDSLayoutPosition4, {
        type: "sticky",
        position: {
            top: "zero",
            zindex: "layer2"
        },
        cloneElement: true
    }, pillsContent));
};
// src/components/product-gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
var __ThumbnailGalleryDialogFragment = gql6(_templateObject5(), PropertyImage.fragment);
var ThumbnailGalleryDialog = function(props) {
    var _thumbnailGalleryDialog_primaryButton, _categorizedImages_find, _thumbnailGalleryDialog_toolbar_icon, _thumbnailGalleryDialog_toolbar, _thumbnailGalleryDialog_toolbar_icon1, _thumbnailGalleryDialog_toolbar1, _thumbnailGalleryDialog_toolbar2;
    var data = props.data, allImages = props.allImages, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, onImageClick = props.onImageClick, categoryIndexState = props.categoryIndexState, imageIndexState = props.imageIndexState, triggerRef = props.triggerRef, propertyId = props.propertyId, onThumbnailGalleryButtonClick = props.onThumbnailGalleryButtonClick;
    var categorizedImages = data.categorizedImages, thumbnailGalleryDialog = data.thumbnailGalleryDialog;
    var reserveButton = thumbnailGalleryDialog === null || thumbnailGalleryDialog === void 0 ? void 0 : (_thumbnailGalleryDialog_primaryButton = thumbnailGalleryDialog.primaryButton) === null || _thumbnailGalleryDialog_primaryButton === void 0 ? void 0 : _thumbnailGalleryDialog_primaryButton.button;
    var scrollTo = useRefTargetScroll().scrollTo;
    var getTargets = useRefContext().getTargets;
    var _useInView = useInView({
        threshold: 0
    }), ref = _useInView.ref, inView = _useInView.inView, entry = _useInView.entry;
    var _useState2 = _sliced_to_array(useState2(false), 2), isScrolled = _useState2[0], setIsScrolled = _useState2[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 2), categoryIndex = _categoryIndexState[0], setCategoryIndex = _categoryIndexState[1];
    var refGallery = React15.useRef(null);
    var track = useClickTracker8();
    useEffect2(function() {
        if (!inView && (entry === null || entry === void 0 ? void 0 : entry.target)) {
            setIsScrolled(true);
        }
    }, [
        inView
    ]);
    var onReserveButtonClick = function() {
        if (reserveButton === null || reserveButton === void 0 ? void 0 : reserveButton.analytics) {
            var _reserveButton_analytics = reserveButton.analytics, linkName = _reserveButton_analytics.linkName, referrerId = _reserveButton_analytics.referrerId;
            var thumbnailReferrerId = "".concat(referrerId, ".Thumbnail_Gallery");
            track(thumbnailReferrerId, linkName);
        }
        setTimeout(function() {
            onDialogDismiss();
            setTimeout(function() {
                var _thumbnailGalleryDialog_primaryButton;
                var targetRef = thumbnailGalleryDialog === null || thumbnailGalleryDialog === void 0 ? void 0 : (_thumbnailGalleryDialog_primaryButton = thumbnailGalleryDialog.primaryButton) === null || _thumbnailGalleryDialog_primaryButton === void 0 ? void 0 : _thumbnailGalleryDialog_primaryButton.targetRef;
                if (targetRef) {
                    scrollTo(targetRef, [
                        {
                            sectionName: "navigation"
                        }
                    ]);
                    setTimeout(function() {
                        var _offersRef_current;
                        var _getTargets = getTargets([
                            targetRef
                        ]), offersRef = _getTargets[targetRef];
                        offersRef === null || offersRef === void 0 ? void 0 : (_offersRef_current = offersRef.current) === null || _offersRef_current === void 0 ? void 0 : _offersRef_current.focus({
                            preventScroll: true
                        });
                    }, 300);
                }
            }, 500);
        }, 300);
    };
    var firstCategorySingleImage = (categorizedImages === null || categorizedImages === void 0 ? void 0 : (_categorizedImages_find = categorizedImages.find(function(category) {
        return category.categoryId === "all";
    })) === null || _categorizedImages_find === void 0 ? void 0 : _categorizedImages_find.images.length) === 1;
    var showReserveButton = isScrolled || firstCategorySingleImage;
    var _reserveButton_accessibility;
    var reserveButtonSmall = reserveButton && /* @__PURE__ */ React15.createElement(EGDSSpacing4, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutPosition5, {
        type: "absolute",
        position: {
            bottom: "six",
            left: "center",
            zindex: "layer1"
        }
    }, /* @__PURE__ */ React15.createElement(EGDSFloatingButton, {
        onClick: onReserveButtonClick,
        "aria-label": (_reserveButton_accessibility = reserveButton.accessibility) !== null && _reserveButton_accessibility !== void 0 ? _reserveButton_accessibility : ""
    }, reserveButton.primary)));
    var _reserveButton_accessibility1;
    var reserveButtonLarge = reserveButton && /* @__PURE__ */ React15.createElement(EGDSPrimaryButton, {
        "aria-label": (_reserveButton_accessibility1 = reserveButton.accessibility) !== null && _reserveButton_accessibility1 !== void 0 ? _reserveButton_accessibility1 : "",
        onClick: onReserveButtonClick
    }, /* @__PURE__ */ React15.createElement(EGDSText3, {
        whiteSpace: "nowrap",
        theme: "light"
    }, reserveButton.primary));
    var toolbarAnalytics = {
        id: "HOT.HIS.PhotoGalleryTrigger",
        description: "Close thumbnail gallery dialog",
        callback: function(id, description) {
            var _categorizedImages_categoryIndex_images, _categorizedImages_categoryIndex;
            var _imageIndexState = _sliced_to_array(imageIndexState, 1), imageIndex = _imageIndexState[0];
            var _categorizedImages_categoryIndex_images_length;
            var maxGalleryIndex = (_categorizedImages_categoryIndex_images_length = (_categorizedImages_categoryIndex = categorizedImages[categoryIndex]) === null || _categorizedImages_categoryIndex === void 0 ? void 0 : (_categorizedImages_categoryIndex_images = _categorizedImages_categoryIndex.images) === null || _categorizedImages_categoryIndex_images === void 0 ? void 0 : _categorizedImages_categoryIndex_images.length) !== null && _categorizedImages_categoryIndex_images_length !== void 0 ? _categorizedImages_categoryIndex_images_length : allImages.length;
            track(id, description, void 0, additionalUisPrimeMicroMessages(imageIndex, void 0, maxGalleryIndex, void 0, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
        }
    };
    var toolbarComponent = thumbnailGalleryDialog && /* @__PURE__ */ React15.createElement(EGDSToolbar, {
        navigationContent: {
            onClick: onDialogDismiss,
            onClickAnalytics: toolbarAnalytics,
            navType: (_thumbnailGalleryDialog_toolbar = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon = _thumbnailGalleryDialog_toolbar.icon) === null || _thumbnailGalleryDialog_toolbar_icon === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon.id,
            navIconLabel: (_thumbnailGalleryDialog_toolbar1 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar1 === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon1 = _thumbnailGalleryDialog_toolbar1.icon) === null || _thumbnailGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon1.description
        },
        toolbarTitle: ((_thumbnailGalleryDialog_toolbar2 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar2 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar2.title) || "",
        toolbarActionContent: /* @__PURE__ */ React15.createElement(Viewport4, null, /* @__PURE__ */ React15.createElement(ViewMedium4, null, /* @__PURE__ */ React15.createElement(React15.Fragment, null, reserveButtonLarge)))
    });
    var sheetProps = {
        returnFocusOnClose: true,
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    var onPillSelect = function(index) {
        setCategoryIndex(index);
        setIsScrolled(true);
    };
    var pillsCategories = function(isSmallView) {
        return /* @__PURE__ */ React15.createElement(ThumbnailGalleryPills, {
            categories: categorizedImages,
            images: allImages,
            onImageClick: onImageClick,
            categoryIndexState: categoryIndexState,
            imageIndexState: imageIndexState,
            propertyId: propertyId,
            showImageNumber: true,
            refGallery: refGallery,
            isSmallView: isSmallView,
            refContent: ref,
            onPillSelect: onPillSelect,
            onThumbnailGalleryButtonClick: onThumbnailGalleryButtonClick
        });
    };
    var sheetContent = function(isSmallView) {
        return /* @__PURE__ */ React15.createElement(React15.Fragment, null, toolbarComponent, /* @__PURE__ */ React15.createElement(EGDSSheetContent, {
            padded: false
        }, /* @__PURE__ */ React15.createElement("div", {
            ref: refGallery
        }, pillsCategories(isSmallView))));
    };
    var fullScreenDialog = /* @__PURE__ */ React15.createElement(EGDSSheet, {
        type: "full",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, toolbarComponent, /* @__PURE__ */ React15.createElement(EGDSSpacing4, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React15.createElement(EGDSSheetContent, {
        padded: false
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutFlex5, {
        justifyContent: "center"
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutFlexItem3, {
        maxWidth: "312x",
        grow: 1
    }, /* @__PURE__ */ React15.createElement("div", {
        ref: refGallery
    }, pillsCategories(false)))))));
    return /* @__PURE__ */ React15.createElement(Viewport4, null, /* @__PURE__ */ React15.createElement(ViewSmall4, null, /* @__PURE__ */ React15.createElement(EGDSSheet, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), sheetContent(true), reserveButtonSmall)), /* @__PURE__ */ React15.createElement(ViewMedium4, null, /* @__PURE__ */ React15.createElement(SheetCenteredLarge, _object_spread_props(_object_spread({}, sheetProps), {
        centeredSheetSize: "xxxlarge",
        height: 1200
    }), sheetContent(false))));
};
ThumbnailGalleryDialog.displayName = "ThumbnailGalleryDialog";
ThumbnailGalleryDialog.fragment = __ThumbnailGalleryDialogFragment;
// src/components/product-gallery/__private/hooks/use-all-images-with-placeholder-images.tsx
import { useMemo as useMemo5 } from "react";
// src/components/product-gallery/__private/hooks/use-all-images.ts
import { useMemo as useMemo4 } from "react";
var useAllImages = function(data) {
    return useMemo4(function() {
        var _data_categorizedImages_find, _data_categorizedImages;
        return (data === null || data === void 0 ? void 0 : (_data_categorizedImages = data.categorizedImages) === null || _data_categorizedImages === void 0 ? void 0 : (_data_categorizedImages_find = _data_categorizedImages.find(function(category) {
            return category.categoryId === data.categoryIdAll;
        })) === null || _data_categorizedImages_find === void 0 ? void 0 : _data_categorizedImages_find.images) || [];
    }, [
        data
    ]);
};
// src/components/product-gallery/__private/hooks/use-all-images-with-placeholder-images.tsx
var useAllImagesWithPlaceholderImages = function(data, images) {
    var allImages = useAllImages(data);
    return useMemo5(function() {
        if (!(images === null || images === void 0 ? void 0 : images.length) || !allImages.length) {
            return allImages;
        }
        var propertyGalleryImagesBaseUrl = allImages.map(function(img) {
            var _img_lowResImage;
            var _img_lowResImage_url, _split_;
            return _object_spread_props(_object_spread({}, img), {
                baseUrl: (_split_ = ((_img_lowResImage_url = (_img_lowResImage = img.lowResImage) === null || _img_lowResImage === void 0 ? void 0 : _img_lowResImage.url) !== null && _img_lowResImage_url !== void 0 ? _img_lowResImage_url : img.image.url).split("?")[0]) !== null && _split_ !== void 0 ? _split_ : ""
            });
        });
        var placeholderImagesWithBaseUrl = images.map(function(img) {
            return _object_spread_props(_object_spread({}, img), {
                baseUrl: img.url.split("?")[0]
            });
        });
        var placeholderDataIndexMap = placeholderImagesWithBaseUrl.reduce(function(idMap, img, index) {
            return _object_spread_props(_object_spread({}, idMap), _define_property({}, img.baseUrl, index));
        }, {});
        var imageUrlMap = placeholderImagesWithBaseUrl.reduce(function(idMap, img) {
            return _object_spread_props(_object_spread({}, idMap), _define_property({}, img.baseUrl, img));
        }, {});
        var mappedPlaceholderImagesWithBaseUrl = propertyGalleryImagesBaseUrl.filter(function(img) {
            return imageUrlMap[img.baseUrl];
        }).map(function(img) {
            var _imageUrlMap_img_baseUrl, _imageUrlMap_img_baseUrl1;
            return _object_spread_props(_object_spread({}, img), {
                image: _object_spread_props(_object_spread({}, img.image), {
                    url: ((_imageUrlMap_img_baseUrl = imageUrlMap[img.baseUrl]) === null || _imageUrlMap_img_baseUrl === void 0 ? void 0 : _imageUrlMap_img_baseUrl.url) || img.image.url
                }),
                lowResImage: _object_spread_props(_object_spread({}, img.lowResImage), {
                    url: ((_imageUrlMap_img_baseUrl1 = imageUrlMap[img.baseUrl]) === null || _imageUrlMap_img_baseUrl1 === void 0 ? void 0 : _imageUrlMap_img_baseUrl1.url) || ""
                })
            });
        });
        var mappedPlaceholderImages = _to_consumable_array(mappedPlaceholderImagesWithBaseUrl).sort(function(a, b) {
            return (placeholderDataIndexMap[a.baseUrl] || -1) - (placeholderDataIndexMap[b.baseUrl] || -1);
        }).map(function(_param) {
            var baseUrl = _param.baseUrl, img = _object_without_properties(_param, [
                "baseUrl"
            ]);
            return img;
        });
        var nonPlaceholderPropertyGalleryImages = allImages.filter(function(_, index) {
            var _propertyGalleryImagesBaseUrl_index;
            var _propertyGalleryImagesBaseUrl_index_baseUrl;
            return !imageUrlMap[(_propertyGalleryImagesBaseUrl_index_baseUrl = (_propertyGalleryImagesBaseUrl_index = propertyGalleryImagesBaseUrl[index]) === null || _propertyGalleryImagesBaseUrl_index === void 0 ? void 0 : _propertyGalleryImagesBaseUrl_index.baseUrl) !== null && _propertyGalleryImagesBaseUrl_index_baseUrl !== void 0 ? _propertyGalleryImagesBaseUrl_index_baseUrl : ""];
        });
        var updatedAllImages = _to_consumable_array(mappedPlaceholderImages).concat(_to_consumable_array(nonPlaceholderPropertyGalleryImages));
        return updatedAllImages;
    }, [
        allImages,
        images
    ]);
};
// src/components/product-gallery/product-gallery-image-container.tsx
var __ProductGalleryImageContainerFragment = gql7(_templateObject6(), MosaicContainer.fragment, CarouselContainer.fragment, MediaGalleryDialog.fragment, ThumbnailGalleryDialog.fragment, GalleryButtons.fragment);
var ProductGalleryImageContainer = function(param) {
    var propertyId = param.propertyId, data = param.data, placeholderData = param.placeholderData, className = param.className, shoppingContext = param.shoppingContext, travelSearchCriteria = param.travelSearchCriteria, onClickSeeAllReviewsButton = param.onClickSeeAllReviewsButton;
    var _data_galleryButtons, _aerialViewButton_icon, _data_thumbnailGalleryDialog_trigger, _data_thumbnailGalleryDialog, _data_thumbnailGalleryDialog_trigger1, _data_thumbnailGalleryDialog1;
    var _useDialog = _sliced_to_array(useDialog("media-gallery", "pwaDialogNested"), 3), isMediaGalleryDialogOpen = _useDialog[0], mediaGalleryDialogActions = _useDialog[1], MediaGalleryDialogWrapper = _useDialog[2];
    var _useDialog1 = _sliced_to_array(useDialog("thumbnail-gallery", "pwaThumbnailDialog"), 3), isThumbnailGalleryDialogOpen = _useDialog1[0], thumbnailGalleryDialogActions = _useDialog1[1], ThumbnailGalleryDialogWrapper = _useDialog1[2];
    var _useDialog2 = _sliced_to_array(useDialog("aerial-view", "pwaAerialDialog"), 3), isAerialViewDialogOpen = _useDialog2[0], aerialViewDialogActions = _useDialog2[1], AerialViewDialogWrapper = _useDialog2[2];
    var triggerBtn = React16.useRef(null);
    var triggerImageBtn = React16.useRef(null);
    var imageIndexState = React16.useState(0);
    var categoryIndexState = React16.useState(-1);
    var categoryImageIndexState = React16.useState(0);
    var mediaGalleryStartIndexState = React16.useState(0);
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), setImageIndex = _imageIndexState[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 2), setCategoryIndex = _categoryIndexState[1];
    var _categoryImageIndexState = _sliced_to_array(categoryImageIndexState, 2), setCategoryImageIndex = _categoryImageIndexState[1];
    var _mediaGalleryStartIndexState = _sliced_to_array(mediaGalleryStartIndexState, 2), setMediaGalleryStartIndex = _mediaGalleryStartIndexState[1];
    var _React16_useState = _sliced_to_array(React16.useState(""), 2), aerialViewUrl = _React16_useState[0], setAerialViewState = _React16_useState[1];
    var allImages = useAllImagesWithPlaceholderImages(data, placeholderData);
    var aerialEvents = useLoggerEvents(AERIAL_EVENTS);
    var useControlBehaviour = useContext2(ProductGalleryContext).useControlBehaviour;
    var pageParams = useQueryParams();
    var deleteParam = useDeleteParam();
    var _useExperiment3_exposure = useExperiment3("Adaptex_campaign_PDP_mosaic_for_large_screens").exposure, adaptexCampaignLargerScreensBucket = _useExperiment3_exposure.bucket;
    var _useExperiment3_exposure1 = useExperiment3("Adaptex_campaign_PDP_mosaic_for_small_screens").exposure, adaptexCampaignMWebBucket = _useExperiment3_exposure1.bucket;
    var isRandomAccessOne = useContext2(RandomAccessOneImageContext).isRandomAccessOne;
    React16.useEffect(function() {
        var adaptexCampaignVariant = adaptexCampaignLargerScreensBucket === 1 || adaptexCampaignMWebBucket === 1;
        if (adaptexCampaignVariant && pageParams.get("imageIndex")) {
            var index = Number(pageParams.get("imageIndex"));
            setImageIndex(index);
            deleteParam("imageIndex");
        }
    }, [
        adaptexCampaignLargerScreensBucket,
        adaptexCampaignMWebBucket,
        deleteParam,
        pageParams,
        setImageIndex
    ]);
    var onMosaicImageClick = React16.useCallback(function(index) {
        setImageIndex(index);
        setCategoryIndex(-1);
        triggerBtn.current = document.activeElement;
        thumbnailGalleryDialogActions.openDialog();
    }, [
        thumbnailGalleryDialogActions,
        setCategoryIndex,
        setImageIndex
    ]);
    var onVirtualTourClick = React16.useCallback(function(imageResource) {
        if (typeof window !== "undefined") {
            window.open(imageResource);
        }
    }, []);
    var onAerialViewClick = React16.useCallback(function() {
        var _ref = _async_to_generator(function(videoId) {
            return _ts_generator(this, function(_state) {
                if (!aerialViewUrl) {
                    fetchAerialViewVideo(videoId).then(function(aerialViewResponse) {
                        var _aerialViewResponse_uris;
                        if (aerialViewResponse === null || aerialViewResponse === void 0 ? void 0 : (_aerialViewResponse_uris = aerialViewResponse.uris) === null || _aerialViewResponse_uris === void 0 ? void 0 : _aerialViewResponse_uris.MP4_MEDIUM) {
                            setAerialViewState(aerialViewResponse.uris.MP4_MEDIUM.landscapeUri);
                            aerialEvents.VIDEO_SUCCESS.log(AERIAL_VIEW_LOGGING.SUCCESS + propertyId);
                        } else {
                            var _aerialViewResponse_error;
                            aerialEvents.VIDEO_FAILED.log({
                                message: AERIAL_VIEW_LOGGING.FAILURE + propertyId,
                                error: aerialViewResponse === null || aerialViewResponse === void 0 ? void 0 : (_aerialViewResponse_error = aerialViewResponse.error) === null || _aerialViewResponse_error === void 0 ? void 0 : _aerialViewResponse_error.message
                            });
                            setAerialViewState("error");
                        }
                    });
                }
                aerialViewDialogActions.openDialog();
                return [
                    2
                ];
            });
        });
        return function(videoId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        aerialViewDialogActions,
        setAerialViewState
    ]);
    var aerialViewButton = data === null || data === void 0 ? void 0 : (_data_galleryButtons = data.galleryButtons) === null || _data_galleryButtons === void 0 ? void 0 : _data_galleryButtons.find(function(button) {
        var _button_icon;
        return ((_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) === "visibility";
    });
    var aerialViewDescription = aerialViewButton === null || aerialViewButton === void 0 ? void 0 : (_aerialViewButton_icon = aerialViewButton.icon) === null || _aerialViewButton_icon === void 0 ? void 0 : _aerialViewButton_icon.description;
    var onCarouselImageClick = React16.useCallback(function() {
        setCategoryIndex(-1);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        thumbnailGalleryDialogActions,
        setCategoryIndex
    ]);
    var onThumbnailImageClick = React16.useCallback(function(index, categoryIndex) {
        triggerImageBtn.current = document.activeElement;
        setCategoryIndex(categoryIndex);
        setCategoryImageIndex(index);
        if (categoryIndex < 0) {
            setImageIndex(index);
        }
        setMediaGalleryStartIndex(index);
        mediaGalleryDialogActions.openDialog();
    }, [
        setCategoryIndex,
        setCategoryImageIndex,
        mediaGalleryDialogActions,
        setImageIndex,
        setMediaGalleryStartIndex
    ]);
    var onOpenThumbnailGalleryDialog = React16.useCallback(function() {
        var activeEl = document.activeElement;
        triggerBtn.current = activeEl;
        setImageIndex(0);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        thumbnailGalleryDialogActions,
        setImageIndex
    ]);
    var onDialogDismiss = React16.useCallback(function() {
        thumbnailGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerBtn_current;
            (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        }, 0);
    }, [
        thumbnailGalleryDialogActions
    ]);
    var onMediaDialogDismiss = React16.useCallback(function() {
        mediaGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerImageBtn_current;
            (_triggerImageBtn_current = triggerImageBtn.current) === null || _triggerImageBtn_current === void 0 ? void 0 : _triggerImageBtn_current.focus();
        }, 0);
    }, [
        mediaGalleryDialogActions
    ]);
    var onAerialDialogDismiss = React16.useCallback(function() {
        aerialViewDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerBtn_current;
            (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        });
    }, [
        aerialViewDialogActions
    ]);
    var carouselRef = React16.useRef(null);
    if (!data || !allImages.length) {
        return null;
    }
    var controlProps = {
        imageIndexState: imageIndexState,
        categoryImageIndexState: categoryImageIndexState,
        categoryIndexState: categoryIndexState
    };
    var containerProps = _object_spread({
        onTriggerClick: onOpenThumbnailGalleryDialog,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        thumbnailDialogTriggerTitle: data === null || data === void 0 ? void 0 : (_data_thumbnailGalleryDialog = data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger = _data_thumbnailGalleryDialog.trigger) === null || _data_thumbnailGalleryDialog_trigger === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger.value,
        thumbnailDialogTriggerAccessibilityLabel: data === null || data === void 0 ? void 0 : (_data_thumbnailGalleryDialog1 = data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog1 === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger1 = _data_thumbnailGalleryDialog1.trigger) === null || _data_thumbnailGalleryDialog_trigger1 === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger1.accessibilityLabel,
        data: data,
        propertyId: propertyId,
        allImages: allImages
    }, controlProps);
    var LoadingPlaceholder = /* @__PURE__ */ React16.createElement(EGDSLayoutPosition6, {
        type: "relative"
    }, /* @__PURE__ */ React16.createElement(EGDSLayoutGrid5, {
        blockSize: "30vb"
    }, /* @__PURE__ */ React16.createElement(EGDSBlockSkeleton, null)));
    var renderGalleryComponent = function(controlComponent) {
        var randomAccessOneComponent = RandomAccessOne({
            inputs: {
                featureId: "image_mosaic_adaptex",
                productIdentifier: {
                    id: propertyId,
                    type: IdentifierType.PROPERTY_ID,
                    shoppingContext: shoppingContext,
                    travelSearchCriteria: travelSearchCriteria
                }
            },
            batchKey: "default-product-details-experience-batch-key",
            loadingPlaceholder: LoadingPlaceholder
        });
        return useControlBehaviour ? controlComponent : randomAccessOneComponent;
    };
    var mosaicComponent = function(imagesToShow) {
        return /* @__PURE__ */ React16.createElement(MosaicContainer, _object_spread({
            onImageClick: function(index) {
                return onMosaicImageClick(index);
            },
            imagesToShow: imagesToShow
        }, containerProps));
    };
    var carouselComponent = /* @__PURE__ */ React16.createElement(CarouselContainer, _object_spread({
        onImageClick: onCarouselImageClick
    }, containerProps));
    var mosaicContainer = function(imagesToShow) {
        return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(Experiment2, {
            name: "Adaptex_campaign_PDP_mosaic_for_large_screens"
        }, /* @__PURE__ */ React16.createElement(ExperimentControl2, null, mosaicComponent(imagesToShow)), /* @__PURE__ */ React16.createElement(ExperimentVariant2, {
            bucket: 1
        }, renderGalleryComponent(mosaicComponent(imagesToShow)))), /* @__PURE__ */ React16.createElement(GalleryButtons, {
            data: data,
            onThumbnailGalleryClick: containerProps.onTriggerClick,
            onVirtualTourClick: onVirtualTourClick,
            onAerialViewClick: onAerialViewClick,
            thumbnailButtonText: containerProps.thumbnailDialogTriggerTitle,
            thumbnailDialogTriggerAccessibilityLabel: containerProps.thumbnailDialogTriggerAccessibilityLabel,
            propertyId: propertyId
        }));
    };
    var carouselContainer = /* @__PURE__ */ React16.createElement(Experiment2, {
        name: "Adaptex_campaign_PDP_mosaic_for_small_screens"
    }, /* @__PURE__ */ React16.createElement(ExperimentControl2, null, carouselComponent), /* @__PURE__ */ React16.createElement(ExperimentVariant2, {
        bucket: 1
    }, renderGalleryComponent(carouselComponent), !useControlBehaviour && /* @__PURE__ */ React16.createElement(GalleryButtons, {
        data: data,
        onThumbnailGalleryClick: containerProps.onTriggerClick,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        thumbnailButtonText: containerProps.thumbnailDialogTriggerTitle,
        thumbnailDialogTriggerAccessibilityLabel: containerProps.thumbnailDialogTriggerAccessibilityLabel,
        propertyId: propertyId
    })));
    return /* @__PURE__ */ React16.createElement("div", {
        className: className
    }, isRandomAccessOne ? /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(Viewport5, null, /* @__PURE__ */ React16.createElement(ViewSmall5, null, carouselComponent), /* @__PURE__ */ React16.createElement(ViewMedium5, null, /* @__PURE__ */ React16.createElement(React16.Fragment, null, mosaicComponent(3), /* @__PURE__ */ React16.createElement(GalleryButtons, {
        data: data,
        onThumbnailGalleryClick: containerProps.onTriggerClick,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        thumbnailButtonText: containerProps.thumbnailDialogTriggerTitle,
        thumbnailDialogTriggerAccessibilityLabel: containerProps.thumbnailDialogTriggerAccessibilityLabel,
        propertyId: propertyId
    })))), /* @__PURE__ */ React16.createElement(EGDSThemeProvider, {
        config: {
            lightMode: {
                colorTheme: "bright-1"
            }
        },
        isColorThemeContainer: true
    }, /* @__PURE__ */ React16.createElement(EGDSSpacing5, {
        padding: "half"
    }, /* @__PURE__ */ React16.createElement("div", {
        "data-stid": "luxury-ribbon"
    })))) : /* @__PURE__ */ React16.createElement(Viewport5, null, /* @__PURE__ */ React16.createElement(ViewSmall5, null, carouselContainer), /* @__PURE__ */ React16.createElement(ViewMedium5, null, mosaicContainer(3)), /* @__PURE__ */ React16.createElement(ViewLarge3, null, mosaicContainer(5))), /* @__PURE__ */ React16.createElement(EGDSSheetTransition, {
        isVisible: isThumbnailGalleryDialogOpen
    }, /* @__PURE__ */ React16.createElement(ThumbnailGalleryDialogWrapper, null, /* @__PURE__ */ React16.createElement(ThumbnailGalleryDialog, _object_spread({
        allImages: allImages,
        data: data,
        isDialogOpen: isThumbnailGalleryDialogOpen,
        onDialogDismiss: onDialogDismiss,
        onImageClick: onThumbnailImageClick,
        triggerRef: triggerBtn,
        propertyId: propertyId,
        onThumbnailGalleryButtonClick: onClickSeeAllReviewsButton
    }, controlProps)))), /* @__PURE__ */ React16.createElement(EGDSSheetTransition, {
        isVisible: isMediaGalleryDialogOpen
    }, /* @__PURE__ */ React16.createElement(MediaGalleryDialogWrapper, null, /* @__PURE__ */ React16.createElement(MediaGalleryDialog, _object_spread({
        allImages: allImages,
        data: data,
        isDialogOpen: isMediaGalleryDialogOpen,
        onDialogDismiss: onMediaDialogDismiss,
        propertyId: propertyId,
        mediaGalleryStartIndexState: mediaGalleryStartIndexState,
        carouselRef: carouselRef
    }, controlProps)))), /* @__PURE__ */ React16.createElement(EGDSSheetTransition, {
        isVisible: isAerialViewDialogOpen
    }, /* @__PURE__ */ React16.createElement(AerialViewDialogWrapper, null, /* @__PURE__ */ React16.createElement(AerialViewDialog, {
        isDialogOpen: isAerialViewDialogOpen,
        onDialogDismiss: onAerialDialogDismiss,
        triggerRef: triggerBtn,
        aerialViewLandscape: aerialViewUrl,
        aerialViewDescription: aerialViewDescription
    }))));
};
ProductGalleryImageContainer.displayName = "ProductGalleryImageContainer";
ProductGalleryImageContainer.fragment = __ProductGalleryImageContainerFragment;
// src/components/product-gallery/product-gallery-placeholder.tsx
import React17, { useContext as useContext3 } from "react";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType6, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
// src/hooks/use-component-mount.ts
import { useEffect as useEffect3, useState as useState3 } from "react";
var useComponentMount = function() {
    var _useState3 = _sliced_to_array(useState3(false), 2), ready = _useState3[0], setReady = _useState3[1];
    useEffect3(function() {
        setReady(true);
    }, []);
    return ready;
};
// src/components/product-gallery/product-gallery-placeholder.tsx
var getImageRatio = function(bucket) {
    switch(bucket){
        case 1:
            return EGDSFigureAspectRatioType6.R3_2;
        case 2:
            return EGDSFigureAspectRatioType6.R1_1;
        default:
            return EGDSFigureAspectRatioType6.R16_9;
    }
};
var ProductGalleryPlaceholder = function(param) {
    var images = param.images;
    var ready = useComponentMount();
    var isRandomAccessOne = useContext3(RandomAccessOneImageContext).isRandomAccessOne;
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, ready ? /* @__PURE__ */ React17.createElement(CSRGalleryPlaceholderChild, {
        images: images,
        isRandomAccessOne: isRandomAccessOne
    }) : /* @__PURE__ */ React17.createElement(SSRGalleryPlaceholderChild, {
        images: images,
        isRandomAccessOne: isRandomAccessOne
    }));
};
var PlaceholderImage = function(param) {
    var additionalImage = param.additionalImage, className = param.className, style = param.style, isRandomAccessOne = param.isRandomAccessOne;
    var _useExperiment4 = useExperiment4("mWeb_larger_image_for_top_of_PDP_gallery"), mWebLargerImageExposure = _useExperiment4.exposure;
    return /* @__PURE__ */ React17.createElement(EGDSFigure4, {
        ratio: isRandomAccessOne ? EGDSFigureAspectRatioType6.R3_2 : getImageRatio(mWebLargerImageExposure.bucket),
        className: className,
        style: style
    }, /* @__PURE__ */ React17.createElement(EGDSImage4, {
        placeholderImage: true,
        src: additionalImage === null || additionalImage === void 0 ? void 0 : additionalImage.url,
        alt: additionalImage === null || additionalImage === void 0 ? void 0 : additionalImage.description,
        additionalProps: {
            fetchPriority: (additionalImage === null || additionalImage === void 0 ? void 0 : additionalImage.url) ? "high" : void 0
        }
    }));
};
var withPlaceholderChild = function(displayName) {
    var Component = function(param) {
        var images = param.images, isRandomAccessOne = param.isRandomAccessOne;
        return /* @__PURE__ */ React17.createElement(Viewport6, null, /* @__PURE__ */ React17.createElement(ViewSmall6, null, /* @__PURE__ */ React17.createElement(PlaceholderImage, {
            additionalImage: images === null || images === void 0 ? void 0 : images[0]
        })), /* @__PURE__ */ React17.createElement(ViewMedium6, null, /* @__PURE__ */ React17.createElement(EGDSLayoutGrid6, {
            rows: 2,
            columns: 3,
            space: "half"
        }, Array.from(Array(3)).map(function(_, index) {
            return /* @__PURE__ */ React17.createElement(EGDSLayoutGridItem4, {
                rowSpan: index === 0 ? 2 : 1,
                colSpan: index === 0 ? 2 : 1,
                key: "gallery-placeholder-".concat(index)
            }, /* @__PURE__ */ React17.createElement(PlaceholderImage, {
                additionalImage: images === null || images === void 0 ? void 0 : images[index],
                isRandomAccessOne: isRandomAccessOne
            }));
        }))), /* @__PURE__ */ React17.createElement(ViewLarge4, null, /* @__PURE__ */ React17.createElement(EGDSLayoutGrid6, {
            rows: 2,
            columns: 4,
            space: "half"
        }, Array.from(Array(isRandomAccessOne ? 3 : 5)).map(function(_, index) {
            return /* @__PURE__ */ React17.createElement(EGDSLayoutGridItem4, {
                rowSpan: index === 0 ? 2 : 1,
                colSpan: index === 0 ? 2 : 1,
                key: "gallery-placeholder-".concat(index)
            }, /* @__PURE__ */ React17.createElement(PlaceholderImage, {
                additionalImage: images === null || images === void 0 ? void 0 : images[index],
                isRandomAccessOne: isRandomAccessOne
            }));
        }))));
    };
    Component.displayName = displayName;
    return Component;
};
var CSRGalleryPlaceholderChild = withPlaceholderChild("CsrPlaceholder");
var SSRGalleryPlaceholderChild = withPlaceholderChild("SsrPlaceholder");
// src/components/product-gallery/product-gallery.tsx
var __Query = gql8(_templateObject7(), ProductGalleryImageContainer.fragment);
var ProductGallery = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, placeholderData = param.placeholderData, batchKey = param.batchKey, onClickSeeAllReviewsButton = param.onClickSeeAllReviewsButton;
    var _randomAccessData_randomAccessOne_mapping, _randomAccessData_randomAccessOne, _mockData_product, _mockData_product1, _data_productGallery_categorizedImages_find, _data_productGallery_categorizedImages, _data_productGallery;
    var context = useBexApi().context;
    var publishSignal = useSignalPublisher().publishSignal;
    var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var mockData = useMockData();
    var _useExperiment5_exposure = useExperiment5("Luxury_PDP_Feature_Gate_Web").exposure, luxuryBucket = _useExperiment5_exposure.bucket;
    var variableRandomAccessOne = {
        context: context,
        featureId: "standout-stays",
        productIdentifier: {
            id: inputs.productIdentifier.id,
            type: IdentifierType2.PROPERTY_ID
        }
    };
    var _useQuery = useQuery(__RandomAccessOneQuery, {
        variables: variableRandomAccessOne,
        ssr: !skipSsr,
        errorPolicy: "all",
        skip: luxuryBucket === 0
    }), randomAccessData = _useQuery.data;
    if (randomAccessData === null || randomAccessData === void 0 ? void 0 : (_randomAccessData_randomAccessOne = randomAccessData.randomAccessOne) === null || _randomAccessData_randomAccessOne === void 0 ? void 0 : (_randomAccessData_randomAccessOne_mapping = _randomAccessData_randomAccessOne.mapping) === null || _randomAccessData_randomAccessOne_mapping === void 0 ? void 0 : _randomAccessData_randomAccessOne_mapping.length) {
        publishSignal({
            type: "LUXURY_PROPERTY",
            payload: {
                message: true
            }
        });
    }
    var _useQuery1 = useQuery(__Query, {
        context: {
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all",
        skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_product = mockData.product) === null || _mockData_product === void 0 ? void 0 : _mockData_product.productGallery
    }), data = _useQuery1.data, loading = _useQuery1.loading;
    var productGallery = (mockData === null || mockData === void 0 ? void 0 : (_mockData_product1 = mockData.product) === null || _mockData_product1 === void 0 ? void 0 : _mockData_product1.productGallery) || (data === null || data === void 0 ? void 0 : data.productGallery);
    var guestPhotosCategoryImpressionAnalytics = data === null || data === void 0 ? void 0 : (_data_productGallery = data.productGallery) === null || _data_productGallery === void 0 ? void 0 : (_data_productGallery_categorizedImages = _data_productGallery.categorizedImages) === null || _data_productGallery_categorizedImages === void 0 ? void 0 : (_data_productGallery_categorizedImages_find = _data_productGallery_categorizedImages.find(function(category) {
        return category.categoryId === "Guest photos" /* GUEST_PHOTOS */ ;
    })) === null || _data_productGallery_categorizedImages_find === void 0 ? void 0 : _data_productGallery_categorizedImages_find.clientSideAnalytics;
    var productGalleryImageContainer = /* @__PURE__ */ React18.createElement(ProductGalleryImageContainer, {
        propertyId: inputs.productIdentifier.id,
        data: productGallery,
        placeholderData: placeholderData,
        shoppingContext: inputs.productIdentifier.shoppingContext,
        travelSearchCriteria: inputs.productIdentifier.travelSearchCriteria,
        onClickSeeAllReviewsButton: onClickSeeAllReviewsButton
    });
    return /* @__PURE__ */ React18.createElement(RandomAccessOneImageContextProvider, {
        data: randomAccessData
    }, loading && /* @__PURE__ */ React18.createElement(ProductGalleryPlaceholder, {
        images: placeholderData
    }), guestPhotosCategoryImpressionAnalytics ? /* @__PURE__ */ React18.createElement(IntersectionTracker5, {
        referrerId: guestPhotosCategoryImpressionAnalytics.referrerId,
        linkName: guestPhotosCategoryImpressionAnalytics.linkName,
        trackOnce: true
    }, productGalleryImageContainer) : productGalleryImageContainer);
};
ProductGallery.displayName = "sharedui-ProductGallery";
// src/__generated__/types.ts
var IdentifierType3 = /* @__PURE__ */ function(IdentifierType4) {
    IdentifierType4["ACTIVITY_ID"] = "ACTIVITY_ID";
    IdentifierType4["CART_ID"] = "CART_ID";
    IdentifierType4["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
    IdentifierType4["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType4["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
    IdentifierType4["OFFER_ID"] = "OFFER_ID";
    IdentifierType4["ORDER_ID"] = "ORDER_ID";
    IdentifierType4["PROPERTY_ID"] = "PROPERTY_ID";
    IdentifierType4["SAILING_TOKEN"] = "SAILING_TOKEN";
    return IdentifierType4;
}(IdentifierType3 || {});
export { IdentifierType3 as IdentifierType, ProductGallery, ProductGalleryAdaptExProvider, ProductGalleryContext }; /* istanbul ignore file -- @preserve */  /* istanbul ignore next -- @preserve */  // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map